import { en } from './en';
import type { Dict } from '../types';

export const tr: Dict = {
  ...en,
  'workingDirPicker.title': "Folder",
  'workingDirPicker.homeTitle': "Choose where this project should live",
  'workingDirPicker.processing': "Processing…",
  'workingDirPicker.select': "Choose working directory",
  'workingDirPicker.clearAria': "Clear working directory",
  'workingDirPicker.replaceFailed': "Could not replace working directory",
  'workingDirPicker.unavailable': "Folder picker is unavailable in this build. Run the desktop app to pick a folder.",
  'workingDirPicker.openUnavailable': "Open this project in the desktop app to show the folder.",
  'workingDirPicker.openFailed': "Could not show this folder",
  'workingDirPicker.showInFileManager': "Show in file manager",
  'workingDirPicker.replace': "Clear and replace directory…",
  'workingDirPicker.recent': "Recent directories",
  'handoff.toTarget': 'Hand off to {target}',
  'handoff.action': 'Hand off',
  'handoff.fallbackTitle': 'No editors found on $PATH - opens in {target}',
  'handoff.chooseTargetAria': 'Choose hand-off target',
  'handoff.notInstalled': 'Not installed',
  'handoff.notDetectedTitle': '{target} - not detected on $PATH',
  'homeHero.promptExamples': "Örnekler",
  'homeHero.footer.designSystem': "Stil",
  'homeHero.footer.autoDesignSystem': "Otomatik",
  'homeHero.footer.autoDesignSystemSummary': "Geçerli istem için en uygun tasarım sistemini ve görsel stili otomatik eşler.",
  'homeHero.footer.ratio': "Oran",
  'homeHero.footer.duration': "Süre",
  'homeHero.footer.resolution': "Çözünürlük",
  'homeHero.footer.speakerNotes': "Notes",
  'homeHero.footer.noSpeakerNotes': "Not yok",
  'homeHero.footer.availableCount': "{n} available",
  'homeHero.footer.noMatches': "No matches",
  'homeHero.moreShortcuts': "Daha fazla",
  'common.cancel': 'İptal et',
  'common.save': 'Kaydet',
  'common.close': 'Kapat',
  'common.delete': 'Sil',
  'common.rename': 'Yeniden adlandır',
  'common.edit': 'Düzenle',
  'common.preview': 'Önizleme',
  'common.share': 'Paylaş',
  'common.search': 'Ara',
  'common.searchEllipsis': 'Ara…',
  'common.loading': 'Yükleniyor…',
  'common.all': 'Hepsi',
  'common.none': 'Hiçbiri',
  'common.default': 'Varsayılan',
  'common.installed': 'kuruldu',
  'common.notInstalled': 'kurulmadı',
  'common.active': 'aktif',
  'common.offline': 'çevrim dışı',
  'common.selected': 'seçili',
  'common.create': 'Oluştur',
  'common.openPreview': 'Önizlemeyi aç',
  'common.exitFullscreen': 'Tam ekrandan çık',
  'common.fullscreen': 'Tam ekran',
  'common.openInNewTab': 'Yeni sekmede aç',
  'common.exportPdf': 'PDF olarak dışa aktar',
  'common.exportZip': 'ZIP olarak indir',
  'common.exportHtml': 'Tekil HTML olarak dışa aktar',
  'common.justNow': 'şimdi',
  'common.minutesAgo': '{n} dakika önce',
  'common.hoursAgo': '{n} saat önce',
  'common.daysAgo': '{n} gün önce',
  'common.weeksAgo': '{n}w ago',
  'common.now': 'şimdi',
  'common.minutesShort': '{n}d',
  'common.hoursShort': '{n}s',
  'common.daysShort': '{n}g',
  'common.untitled': 'Başlıksız',

  'app.brand': 'Open Design',
  'app.brandPill': 'Önizleme Araştırması',
  'app.brandSubtitle': 'Nexu Labs tarafından',
  'app.welcomeLoading': 'Çalışma alanı yükleniyor…',

  'settings.welcomeKicker': "",
  'settings.welcomeTitle': "Welcome",
  'settings.welcomeSubtitle': "",
  'settings.onboardingCreateTitle': 'Start from a brief',
  'settings.onboardingCreateBody':
    'Describe the site, app, deck, image, or video you want. Open Design will create a project and keep the work editable.',
  'settings.onboardingMemoryTitle': 'Save working context',
  'settings.onboardingMemoryBody':
    'Add preferences, project facts, and recurring rules so future chats pick up the right context.',
  'settings.onboardingSystemsTitle': 'Bring your design system',
  'settings.onboardingSystemsBody':
    'Pick or create a brand system so generated work follows real colors, typography, and product language.',
  'settings.onboardingExecutionTitle': 'Choose how generation runs',
  'settings.onboardingExecutionBody':
    'Use a local CLI agent or connect your own API key. You can change this any time in Settings.',
  'settings.onboardingStepConnect': "Connect",
  'settings.onboardingStepDesignSystem': "Design system",
  'settings.onboardingStepProfile': "About you",
  'settings.onboardingConnectTitle': "Choose a runtime",
  'settings.onboardingConnectBody': "",
  'settings.onboardingRecommended': "Recommended",
  'settings.onboardingLocalTitle': "Local coding agent",
  'settings.onboardingLocalBody': "Use an installed CLI such as Claude Code, Codex, Cursor, Gemini, or OpenCode.",
  'settings.onboardingLocalAction': "Open CLI settings",
  'settings.onboardingCliScanHint': "This usually takes 5-10 seconds.",
  'settings.onboardingByokTitle': "Bring your own key",
  'settings.onboardingByokBody': "Use your own model provider credentials.",
  'settings.onboardingByokAction': "Open BYOK settings",
  'settings.onboardingDesignTitle': "Design system",
  'settings.onboardingDesignBody': "Generate once, reuse everywhere.",
  'settings.onboardingDesignIntroGenerateTitle': "Generate from existing work",
  'settings.onboardingDesignIntroGenerateBody': "Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.",
  'settings.onboardingDesignIntroReuseTitle': "Reuse in future work",
  'settings.onboardingDesignIntroReuseBody': "Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.",
  'settings.onboardingDesignIntroSkipTitle': "Optional for now",
  'settings.onboardingDesignIntroSkipBody': "Skip this step if you want to start without generating a design system.",
  'settings.onboardingGithubTitle': "Import from GitHub",
  'settings.onboardingGithubBody': "Use a frontend repository.",
  'settings.onboardingUploadTitle': "Upload local files",
  'settings.onboardingUploadBody': "Add project files, screenshots, CSS, docs, or assets.",
  'settings.onboardingPromptTitle': "Generate from prompt",
  'settings.onboardingPromptBody': "Describe the product or brand.",
  'settings.onboardingProfileTitle': "About you",
  'settings.onboardingProfileBody': "Optional details for better defaults.",
  'settings.onboardingRoleLabel': "Your role",
  'settings.onboardingOrgSizeLabel': "Organization size",
  'settings.onboardingUseCaseLabel': "Use case",
  'settings.onboardingSourceLabel': "Where did you hear about us?",
  'settings.onboardingSelectPlaceholder': "Select one",
  'settings.onboardingSelectMultiplePlaceholder': "Select one or more",
  'settings.onboardingOrgSolo': "Solo / personal (1)",
  'settings.onboardingOrgTeam': "Small team (2-10)",
  'settings.onboardingOrgStartup': "Startup / SMB (11-50)",
  'settings.onboardingOrgGrowth': "Growth company (51-200)",
  'settings.onboardingOrgMidMarket': "Mid-market (201-1000)",
  'settings.onboardingOrgEnterprise': "Enterprise (1000+)",
  'settings.onboardingRolePm': "📋 Product manager",
  'settings.onboardingRoleDesigner': "🎨 Designer",
  'settings.onboardingRoleEngineer': "💻 Engineer",
  'settings.onboardingRoleMarketing': "📣 Marketing",
  'settings.onboardingRoleGrowth': "📈 Growth",
  'settings.onboardingRoleOps': "⚙️ Operations",
  'settings.onboardingRoleFounder': "🚀 Founder / executive",
  'settings.onboardingRoleStudent': "🎓 Student / educator",
  'settings.onboardingRoleOther': "✨ Other",
  'settings.onboardingUseProduct': "🎨 Product design",
  'settings.onboardingUseDesignSystem': "🧩 Design system",
  'settings.onboardingUsePrototype': "📱 Prototype / app UI",
  'settings.onboardingUseLanding': "🌐 Landing pages",
  'settings.onboardingUseAds': "📣 Ads / social content",
  'settings.onboardingUseDashboard': "📊 Dashboards / internal tools",
  'settings.onboardingUseDeck': "🖥️ Presentation / deck",
  'settings.onboardingUseMarketing': "📈 Marketing / growth",
  'settings.onboardingUseEngineering': "🤝 Engineering handoff",
  'settings.onboardingUseAgency': "💼 Agency / client work",
  'settings.onboardingSourceGithub': "🐙 GitHub",
  'settings.onboardingSourceFriend': "👥 Friend or coworker",
  'settings.onboardingSourceSocial': "📱 Social media",
  'settings.onboardingSourceProductHunt': "🅿️ Product Hunt",
  'settings.onboardingSourceCommunity': "💬 Design / AI community",
  'settings.onboardingSourceYoutube': "▶️ YouTube",
  'settings.onboardingSourceBlog': "📰 Blog or newsletter",
  'settings.onboardingSourceAiTool': "✨ AI tool recommendation",
  'settings.onboardingSourceSearch': "🔍 Search",
  'settings.onboardingSourceEvent': "🎤 Event or community",
  'settings.onboardingBack': "Back",
  'settings.onboardingContinue': "Continue",
  'settings.onboardingFinish': "Finish setup",
  'settings.onboardingSkip': "Skip for now",
  'settings.kicker': 'Ayarlar',
  'settings.title': 'Yürütme modu',
  'settings.subtitle': 'Yerel CLI ile BYOK arasında seçim yapın.',
  'settings.modeAria': 'Çalıştırma modu',
  'settings.protocolAria': 'API protokolü',
  'settings.modeDaemon': 'Yerel CLI',
  'settings.modeDaemonHelp': 'Yerel kod ajanı CLI ile çalıştır',
  'settings.modeDaemonOffline': 'Arka plan servisi çalışmıyor',
  'settings.modeDaemonOfflineMeta': 'Arka plan servisi devre dışı',
  'settings.modeDaemonInstalledMeta': '{count} kuruldu',
  'settings.modeApi': 'API sağlayıcısı',
  'settings.modeApiMeta': 'BYOK',
  'settings.codeAgent': 'Kod ajanı',
  'settings.codeAgentHint':
    'Yerel PATH taranarak tespit edildi. Oluşum akışının yaşanacağı CLI aracınızı seçin.',
  'settings.rescan': '↻ Yeniden tara',
  'settings.rescanTitle': 'PATH’ı yeniden tara',
  'settings.rescanRunning': 'Taranıyor...',
  'settings.rescanSuccess': 'Tarama tamamlandı. {count} kullanılabilir.',
  'settings.designSystemRenameFailed': 'Yeniden adlandırma başarısız. Daemon’u kontrol edip tekrar deneyin.',
  'settings.rescanFailed': 'Tarama başarısız. Daemon’u kontrol edip tekrar deneyin.',
  'settings.test': 'Test',
  'settings.testTitle': 'Bağlantıyı doğrulamak için minik bir test istemi gönderin',
  'settings.testRunning': 'Bağlantı test ediliyor…',
  'settings.testCancel': 'İptal',
  'settings.testSuccessApi': 'Bağlandı. {ms} ms içinde yanıtladı — \'{sample}\'',
  'settings.testSuccessCli': '{agentName}, {ms} ms içinde yanıtladı — \'{sample}\'',
  'settings.testAuthFailed': 'Kimlik doğrulama başarısız. API anahtarınızı kontrol edin.',
  'settings.testForbidden': 'Erişim yasak. Hesabı, bölgeyi veya kuruluşu doğrulayın.',
  'settings.testNotFoundModel': 'Bu uçta \'{model}\' modeli bulunamadı.',
  'settings.testInvalidModelId': '\'{model}\' model id geçersiz. Özel id harf veya rakamla başlamalı ve boşluk içermemelidir.',
  'settings.testInvalidBaseUrl': 'Base URL geçersiz veya erişilemez.',
  'settings.testRateLimited': 'Sağlayıcı testi hız sınırladı. Yapılandırma geçerli görünüyor.',
  'settings.testUpstream': 'Sağlayıcı {status} döndürdü. Birazdan tekrar deneyin.',
  'settings.testTimeout': 'Test {ms} ms sonra zaman aşımına uğradı.',
  'settings.testAgentMissing': '{agentName} yüklü değil veya PATH\'te yok.',
  'settings.testAgentSpawn': '{agentName} başlatılamadı: {detail}.',
  'settings.testUnknown': 'Test başarısız: {detail}',
  'settings.agentInstall.install': 'Yükle',
  'settings.agentInstall.docs': 'Dokümanlar',
  'settings.agentInstall.pathHint':
    'Bir CLI\'yi npm veya Homebrew ile kurduysan ancak hâlâ kurulu değil olarak görünüyorsa, aracın bin dizininin Open Design daemon\'unun devraldığı PATH içinde olduğundan emin ol (macOS\'te Terminal ve GUI uygulamalarının PATH\'i farklı olabilir). QUICKSTART.md içindeki "Local agent CLI and PATH" bölümüne bak.',
  'settings.agentInstall.stepOpenLinks': 'Tercih ettiğin ajan için Yükle veya Dokümanlar bağlantısını aç.',
  'settings.agentInstall.stepAuth':
    'Open Design\'a dönmeden önce sağlayıcı CLI\'sinde kimlik doğrulaması yap (oturum aç veya API kimlik bilgileri ekle).',
  'settings.agentInstall.stepRescan': 'Bu bölümde Yeniden tara\'ya tıkla.',
  'settings.agentInstall.stepSelect': 'Ajan yüklü olarak göründüğünde kartını seç.',
  'settings.noAgentsDetected':
    'Hiçbir ajan tespit edilemedi. Claude Code, Codex, Devin for Terminal, Gemini CLI, OpenCode, Cursor Agent, Qwen, veya GitHub Copilot CLI’lardan birini kurun ve yeniden tarayın.',
  'settings.agentInstalledGroup': 'CLI\'larınız ({count})',
  'settings.agentInstallGroup': 'Kurulabilir ({count})',
  'settings.agentAuthRequired': 'Kimlik doğrulama gerekli',
  'settings.agentAuthUnknown': 'Kimlik doğrulama durumu bilinmiyor',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'Sağlayıcıyı hızlı doldur',
  'settings.customProvider': 'Özel sağlayıcı',
  'settings.apiKey': 'API anahtarı',
  'settings.showKey': 'Anahtarı göster',
  'settings.hideKey': 'Anahtarı gizle',
  'settings.show': 'Göster',
  'settings.hide': 'Gizle',
  'settings.model': 'Model',
  'settings.suggestedModelsHint':
    'Bunlar bu protokol için önerilen modellerdir. Sağlayıcınız farklı modelleri destekleyebilir.',
  'settings.baseUrl': 'Temel URL',
  'settings.baseUrlInvalid': 'Geçerli bir genel http:// veya https:// URL girin. Localhost izinlidir; özel ağ IPleri engellenir.',
  'settings.baseUrlCustomize': 'Özelleştir',
  'settings.baseUrlDefaultHint': 'Varsayılan uç nokta. Genellikle değiştirmeniz gerekmez.',
  'settings.azureBaseUrlPlaceholder': 'https://my-resource.openai.azure.com',
  'settings.azureBaseUrlHint': 'Find this in Azure portal → your resource → Endpoint.',
  'settings.azureDeploymentModel': 'Dağıtım adı',
  'settings.azureDeploymentModelHint':
    'Azure OpenAI icin bu alan /openai/deployments/<model> icindeki dagitim adi olarak kullanilir. Azureda olusturdugunuz dagitim adini girin.',
  'settings.apiVersion': 'API sürümü',
  'settings.byokImageModel': 'Görüntü oluşturma modeli',
  'settings.maxTokens': 'Maks. token (isteğe bağlı)',
  'settings.maxTokensHint':
    'Yanıt uzunluğu sınırı. Her modelin ayarlanmış bir varsayılanı vardır (yer tutucuda görünür); kullanmak için boş bırakın, üzerine yazmak için bir sayı girin.',
  'settings.apiHint': 'İstekler yerel daemon proxy üzerinden ayarladığınız Base URLye gönderilir. Anahtar yalnızca bu tarayıcıda saklanır ve sağlayıcı istekleriyle birlikte gönderilir.',
  'settings.skipForNow': 'Şimdilik atla',
  'settings.getStarted': 'Başla',
  'settings.envConfigure': 'Yürütme modu',
  'settings.localCli': 'Yerel CLI',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'Ajan seçilmedi',
  'settings.language': 'Dil',
  'settings.languageHint': 'Arayüz dilini değiştirin. Bu tarayıcıya kaydedilir.',
  'settings.appearance': 'Görünüm',
  'settings.appearanceHint': 'Açık, koyu veya sistem ayarını takip et.',
  'settings.themeSystem': 'Sistem',
  'settings.themeLight': 'Açık',
  'settings.themeDark': 'Koyu',
  'settings.agentModelHead': 'Model için:',
  'settings.modelPicker': 'Model',
  'settings.modelSourceLive': 'CLI\'dan canlı',
  'settings.modelSourceFallback': 'Yerleşik liste',
  'settings.reasoningPicker': 'Akıl yürütme eforu',
  'settings.modelPickerHint':
    'Bir `models` komutu açığa çıkaran CLI’lardan getirilir. "Varsayılan" seçimi CLI’ın kendi ayarına bırakır; "Özel…" CLI’ın kabul edeceği herhangi bir model kimliği seçmenize izin verir.',
  'settings.modelPickerLiveHint':
    'Modeller kurulu CLI\'dan yenilendi. Varsayılan seçenek hâlâ CLI yapılandırmasını kullanır.',
  'settings.modelPickerFallbackHint':
    'Yerleşik varsayılanlar gösteriliyor. CLI\'dan canlı modelleri almak için Yeniden tara\'ya tıklayın.',
  'settings.modelCustom': 'Özel (aşağıya yazın)…',
  'settings.modelCustomLabel': 'Özel model kimliği',
  'settings.modelCustomPlaceholder': 'örn. anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Medya sağlayıcıları',
  'settings.mediaProvidersHint':
    'Görsel, video ve ses oluşumu için API anahtarları. Yerel saklanır ve yerel arka plan servisiyle senkronize edilir.',
  'settings.mcpServerTitle': 'MCP sunucusu',
  'settings.mcpServerHint': 'Open Design\'ı kodlama ajanınız için MCP sunucusu olarak yayınlayın.',
  'settings.externalMcpTitle': 'Dış MCP',
  'settings.externalMcpHint': 'Dış servislerden (Higgsfield, GitHub, …) MCP araçları ekleyin.',
  'settings.mediaProviderApiKey': 'API anahtarı',
  'settings.mediaProviderBaseUrl': 'Temel URL',
  'settings.mediaProviderConfigured': 'Ayarlandı',
  'settings.mediaProviderUnset': 'Ayarlanmadı',
  'settings.mediaProviderClear': 'Temizle',
  'settings.mediaProviderClearConfirm': 'Kayıtlı {name} ayarları silinsin mi? {name}\'ı tekrar kullanmak için bunları yeniden girmeniz gerekecek.',
  'settings.mediaProviderPlaceholder': 'API anahtarı yapıştır',
  'settings.mediaProviderBaseUrlPlaceholder': 'Varsayılan temel URL’yi görmezden gel',
  'settings.mediaProviderReload': 'Daemon’dan yeniden yükle',
  'settings.mediaProviderReloadError': 'Medya sağlayıcı ayarları yerel daemon’dan yeniden yüklenemedi.',
  'settings.mediaProviderReloadSuccess': 'Medya sağlayıcı ayarları yerel daemon’dan yeniden yüklendi.',
  'settings.mediaProviderLoadError': 'Medya sağlayıcı ayarları yerel daemon’dan yüklenemedi. Şimdilik tarayıcıya kaydedilen ayarlar kullanılıyor.',
  'settings.mediaProviderComingSoonHint': 'Bunları yol haritası için takip ediyoruz; daemon henüz bir istemci göndermediği için yapılandırılacak bir şey yok.',
  'settings.privacy': 'Privacy',
  'settings.privacyHint': 'What data is shared with the Open Design team',
  'settings.privacyConsentKicker': 'Help us improve Open Design',
  'settings.privacyConsentLead': 'Open Design can share usage data with our team to help us improve. This includes:',
  'settings.privacyConsentFooter': 'You can change either of these any time in Settings → Privacy. We never upload the contents of your generated artifact files.',
  'settings.privacyConsentShare': 'Share usage data',
  'settings.privacyConsentDecline': "Don't share",
  'settings.privacyConsentAccept': 'I get it',
  'settings.privacyConsentBannerFooter':
    'Data sharing is on by default. You can turn it off any time in Settings → Privacy. We never upload the contents of your generated artifact files.',
  'settings.privacyConsentPolicyLink': 'Read the privacy policy',
  'settings.privacyMetrics': 'Anonymous metrics',
  'settings.privacyMetricsHint': 'Run counts, token usage, error rate, duration. No prompts, no project data.',
  'settings.privacyContent': 'Conversation content',
  'settings.privacyContentHint': "Your prompts and the assistant's responses (truncated 8 KB / 16 KB). API keys, tokens, JWTs, emails, IPs, and credit-card numbers are stripped automatically before send.",
  'settings.privacyArtifacts': 'Project artifacts manifest',
  'settings.privacyArtifactsHint': 'Filenames, types, sizes of generated files. File contents are never sent.',
  'settings.privacyInstallationId': 'Anonymous ID',
  'settings.privacyOptedOut': 'opted out',
  'settings.privacyDataDeletion': 'Delete my data',
  'settings.privacyDataDeletionHint': 'Rotates your anonymous ID and stops sending. Existing traces age out under our retention policy.',
  'settings.about': 'Hakkında',
  'settings.aboutHint': 'Sürüm ve çalışma zamanı detayları',
  'settings.appVersion': 'Sürüm',
  'settings.appChannel': 'Kanal',
  'settings.appRuntime': 'Çalışma zamanı',
  'settings.appPlatform': 'Platform',
  'settings.appArchitecture': 'Mimari',
  'settings.runtimePackaged': 'Paketlenmiş uygulama',
  'settings.runtimeDevelopment': 'Geliştirme',
  'settings.versionUnavailable': 'Arka plan servisi devre dışıyken sürüm detayları mevcut değildir.',
  'settings.installLatest': 'En son sürümü yükle',
  'settings.alreadyLatest': 'En son sürüme sahipsiniz',

  'entry.tabDesigns': 'Tasarımlar',
  'entry.tabTemplates': 'Şablonlar',
  'entry.tabDesignSystems': 'Tasarım sistemleri',
  'entry.tabConnectors': 'Bağlayıcılar',
  'entry.openSettingsTitle': 'Ayarlar',
  'entry.openSettingsAria': 'Ayarları aç',
  'entry.resizeAria': 'Yan çubuğu yeniden boyutlandır',
  'entry.loadingWorkspace': 'Çalışma alanı yükleniyor…',
  'entry.useEverywhereTitle': 'Her yerde kullan',
  'entry.useEverywhereAria': '“Her yerde kullan” kılavuzunu aç (CLI, MCP, HTTP, Skills)',
  'entry.navNewProject': 'Yeni proje',
  'entry.navHome': 'Ana sayfa',
  'entry.navProjects': 'Projeler',
  'entry.navDesignSystems': 'Tasarım sistemleri',
  'entry.helpAria': 'Yardım',
  'entry.helpMenuAria': 'Yardım menüsü',
  'entry.helpGetHelp': 'GitHub üzerinden yardım alın',
  'entry.helpSubmitFeature': 'Özellik öner',
  'entry.helpWhatsNew': 'Yenilikler',
  'entry.helpDownloadDesktop': 'Masaüstü uygulamasını indir',
  'entry.githubStarLabel': 'Star',
  'entry.githubStarTitle': 'GitHub üzerinde bize yıldız verin',
  'entry.githubStarAria': 'Open Design\u2019a GitHub üzerinde yıldız ver',
  'entry.tabImageTemplates': 'Görsel istemleri',
  'entry.tabVideoTemplates': 'Video istemleri',
  'promptTemplates.searchPlaceholder': 'Şablon ara…',
  'promptTemplates.countLabel': '{n} sonuç',
  'promptTemplates.emptyImage': 'Henüz görsel istemi şablonu yüklenmedi.',
  'promptTemplates.emptyVideo': 'Henüz video istemi şablonu yüklenmedi.',
  'promptTemplates.emptyNoMatch': 'Aramanıza uygun şablon bulunamadı.',
  'promptTemplates.attributionFooter': 'Herkese açık istem kütüphanesinden adape edildi. Her kart orijinal yazara bağlantılıdır.',
  'promptTemplates.openPreviewTitle': 'istemi aç ve önizle',
  'promptTemplates.sourcePrefix': 'Kaynak:',
  'promptTemplates.fetchError': 'Bu şablon gövdesi yüklenemedi.',
  'promptTemplates.promptLabel': 'İstem gövdesi',
  'promptTemplates.copyPrompt': 'İstemi kopyala',
  'promptTemplates.copyDone': 'Kopyalandı!',
  'promptTemplates.modelHint': 'Tavsiye edilen model: {model}',
  'promptTemplates.openSource': 'Orijinali görüntüle',
  'promptTemplates.openFullscreen': 'Tam ekran ön izlemeyi aç',
  'promptTemplates.closeFullscreen': 'Tam ekran ön izlemeyi kapat',
  'promptTemplates.allSources': 'Tüm kaynaklar',
  'promptTemplates.sourceFilterAria': 'Kaynağa göre filtrele',
  'promptTemplates.retry': 'Yeniden dene',

  'connectors.title': 'Bağlayıcılar',
  'connectors.subtitle': 'Canlı artefaktları besleyebilecek yerel ve gelecekteki veri kaynakları.',
  'connectors.account': 'Hesap',
  'connectors.noAccount': 'Bağlı değil',
  'connectors.tools': 'Araçlar',
  'connectors.connect': 'Bağlan',
  'connectors.disconnect': 'Bağlantıyı kes',
  'connectors.authorizationPending': 'Yetkilendirme bekleniyor...',
  'connectors.authorizationPendingHint': 'Yetkilendirmeyi açılan pencerede tamamlayın.',
  'connectors.cancelAuthorization': 'İptal',
  'connectors.configure': 'Yapılandır',
  'connectors.unavailable': 'Kullanılamıyor',
  'connectors.phaseStubTitle': 'Bağlayıcı API\'leri 3. aşamada gelecek; burası yalnızca önizleme yüzeyi.',
  'connectors.statusAvailable': 'Kullanılabilir',
  'connectors.statusConnected': 'Bağlı',
  'connectors.statusError': 'Hata',
  'connectors.statusDisabled': 'Devre dışı',
  'connectors.gateTitle': 'Devam etmek için Composio API anahtarınızı ekleyin',
  'connectors.gateBody': 'Kullanılabilir entegrasyonları yüklemek için anahtarınızı yukarıya yapıştırın ve Anahtarı kaydet’e tıklayın.',
  'connectors.aboutLabel': 'Hakkında',
  'connectors.detailsLabel': 'Ayrıntılar',
  'connectors.statusLabel': 'Durum',
  'connectors.category.aiAgents': 'AI ajanları',
  'connectors.category.aiInfrastructure': 'AI altyapısı',
  'connectors.category.accounting': 'Muhasebe',
  'connectors.category.admin': 'Yönetim',
  'connectors.category.advertising': 'Reklam',
  'connectors.category.analytics': 'Analitik',
  'connectors.category.automation': 'Otomasyon',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Takvim',
  'connectors.category.commerce': 'Ticaret',
  'connectors.category.communication': 'İletişim',
  'connectors.category.contacts': 'Kişiler',
  'connectors.category.dataPlatform': 'Veri platformu',
  'connectors.category.database': 'Veritabanı',
  'connectors.category.design': 'Tasarım',
  'connectors.category.developer': 'Geliştirici araçları',
  'connectors.category.documentation': 'Dokümantasyon',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Eğitim',
  'connectors.category.email': 'E-posta',
  'connectors.category.events': 'Etkinlikler',
  'connectors.category.fieldService': 'Saha servisi',
  'connectors.category.finance': 'Finans',
  'connectors.category.fitness': 'Fitness',
  'connectors.category.forms': 'Formlar',
  'connectors.category.gaming': 'Oyun',
  'connectors.category.hr': 'İK',
  'connectors.category.hospitality': 'Konaklama',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Entegrasyon',
  'connectors.category.localization': 'Yerelleştirme',
  'connectors.category.logistics': 'Lojistik',
  'connectors.category.maps': 'Haritalar',
  'connectors.category.marketing': 'Pazarlama',
  'connectors.category.media': 'Medya',
  'connectors.category.meetings': 'Toplantılar',
  'connectors.category.nonprofit': 'Kâr amacı gütmeyen',
  'connectors.category.observability': 'Gözlemlenebilirlik',
  'connectors.category.payments': 'Ödemeler',
  'connectors.category.personal': 'Kişisel',
  'connectors.category.presentations': 'Sunumlar',
  'connectors.category.procurement': 'Satın alma',
  'connectors.category.product': 'Ürün',
  'connectors.category.productivity': 'Verimlilik',
  'connectors.category.projectManagement': 'Proje yönetimi',
  'connectors.category.recruiting': 'İşe alım',
  'connectors.category.research': 'Araştırma',
  'connectors.category.salesIntelligence': 'Satış zekâsı',
  'connectors.category.scheduling': 'Zamanlama',
  'connectors.category.search': 'Arama',
  'connectors.category.security': 'Güvenlik',
  'connectors.category.signing': 'İmzalama',
  'connectors.category.social': 'Sosyal',
  'connectors.category.spreadsheets': 'E-tablolar',
  'connectors.category.storage': 'Depolama',
  'connectors.category.support': 'Destek',
  'connectors.category.surveys': 'Anketler',
  'connectors.category.tasks': 'Görevler',
  'connectors.category.timeTracking': 'Zaman takibi',
  'connectors.category.video': 'Video',
  'connectors.category.whiteboard': 'Beyaz tahta',
  'connectors.categoryLabel': 'Kategori',
  'connectors.providerLabel': 'Sağlayıcı',
  'connectors.toolsSection': 'Araçlar',
  'connectors.toolsLoading': 'Araçlar yükleniyor…',
  'connectors.noToolsAvailable': 'Henüz kullanılabilir araç yok. Bağlandıktan sonra bu entegrasyonun yetenekleri görünür.',
  'connectors.toolDetailsUnavailable': 'Tool details are unavailable, but this connector reports {n} tools.',
  'connectors.loadMoreTools': 'Load more tools',
  'connectors.openDetailsAria': '{name} ayrıntılarını aç',
  'connectors.toolsBadgeNone': 'Araç yok',
  'connectors.toolsBadgeOne': '{n} araç',
  'connectors.toolsBadgeMany': '{n} araç',
  'connectors.searchPlaceholder': 'Bağlayıcı ara…',
  'connectors.searchAriaLabel': 'Bağlayıcıları ada, sağlayıcıya veya araca göre ara',
  'connectors.searchClear': 'Aramayı temizle',
  'connectors.emptyNoMatchTitle': '“{query}” ile eşleşen bağlayıcı yok',
  'connectors.emptyNoMatchBody': 'Başka bir anahtar kelime deneyin veya tüm kataloğu görmek için aramayı temizleyin.',
  'connectors.emptyNoMatchAction': 'Aramayı temizle',

  'newproj.tabPrototype': 'Prototip',
  'newproj.tabDeck': 'Slayt gösterisi',
  'newproj.tabTemplate': 'Şablondan',
  'newproj.tabMedia': 'Medya',
  'newproj.tabOther': 'Diğer',
  'newproj.titlePrototype': 'Yeni prototip',
  'newproj.titleDeck': 'Yeni slayt gösterisi',
  'newproj.titleTemplate': 'Bir şablondan başla',
  'newproj.titleImage': 'Yeni görsel',
  'newproj.titleVideo': 'Yeni video',
  'newproj.titleAudio': 'Yeni ses',
  'newproj.titleMedia': 'Yeni medya',
  'newproj.titleOther': 'Yeni proje',
  'newproj.namePlaceholder': 'Proje ismi',
  'newproj.fidelityLabel': 'Sadakat',
  'newproj.fidelityWireframe': 'İskelet',
  'newproj.fidelityHigh': 'Yüksek sadakat',
  'newproj.toggleSpeakerNotes': 'Konuşmacı notlarını kullan',
  'newproj.toggleSpeakerNotesHint': 'Slaytlarda daha az metin — konuşma noktalarını notlarda tut.',
  'newproj.toggleAnimations': 'Animasyonları dahil et',
  'newproj.toggleAnimationsHint':
    'Şablonunuzun üstüne hareket (giriş, yüzme, geçişler) ekleyin.',
  'newproj.templateLabel': 'Şablon',
  'newproj.noTemplatesTitle': 'Henüz şablon yok',
  'newproj.noTemplatesBody':
    'Herhangi bir projeyi açın, ardından dosya görüntüleyicideki Paylaş menüsü ile bir şablona dönüştürün. Şablonlar burada görünür.',
  'newproj.savedTemplate': 'Şablon kaydedildi',
  'newproj.fileSingular': 'dosya',
  'newproj.filePlural': 'dosyalar',
  'newproj.create': 'Oluştur',
  'newproj.createFromTemplate': 'Şablondan oluştur',
  'newproj.createDisabledTitle':
    'Önce bir projeyi şablon olarak kaydedin (herhangi bir projenin içinde Paylaş menüsünden).',
  'newproj.importClaudeZip': 'Claude Design ZIP’i içe aktar',
  'newproj.importClaudeZipTitle': 'Bir Claude Design .zip’ini içe aktarın',
  'newproj.importingClaudeZip': 'İçe aktarılıyor…',
  'newproj.privacyFooter': 'Projeyi varsayılan olarak yalnızca siz görebilirsiniz.',
  'newproj.designSystem': 'Tasarım sistemi',
  'newproj.dsNoneFreeform': 'Hiçbiri — serbest stil',
  'newproj.dsNoneSubtitleEmpty': 'Sistem tokeni yok, kendi paletinizi seçin',
  'newproj.dsNoneSubtitleSelected': 'Sistem tokenlerini atla. Ajan kendi paletini seçer.',
  'newproj.dsCategoryFallback': 'Tasarım sistemi',
  'newproj.dsSearch': 'Tasarım sistemleri ara…',
  'newproj.dsModeAria': 'Seçim modu',
  'newproj.dsModeSingle': 'Tekli',
  'newproj.dsModeMulti': 'Çoklu',
  'newproj.dsNoneTitle': 'Hiçbiri — serbest stil',
  'newproj.dsNoneSub': 'Sistem tokenlerini atla. Ajan kendi paletini seçer.',
  'newproj.dsEmpty': 'Hiçbir tasarım sistemi “{query}” aramasıyla örtüşmedi.',
  'newproj.dsFootSingular': 'yalnızca ilhamdır.',
  'newproj.dsFootPlural': 'yalnızca ilhamdır.',
  'newproj.dsFootClear': 'Temizle',
  'newproj.dsBadgeDefault': 'VARSAYILAN',
  'newproj.dsPrimaryFallback': 'Birincil',
  'newproj.surfaceImage': 'Görsel',
  'newproj.surfaceVideo': 'Video',
  'newproj.surfaceAudio': 'Ses',
  'newproj.modelLabel': 'Model',
  'newproj.modelSearch': 'Modelleri ara…',
  'newproj.modelEmpty': 'Eşleşen model yok.',
  'newproj.modelRecommended': 'Önerilen',
  'newproj.modelMissingTitle': 'Model seç',
  'newproj.modelMissingSub': 'Bu yüzey için bir model seç.',
  'newproj.aspectLabel': 'Oran',
  'newproj.videoLengthLabel': 'Uzunluk',
  'newproj.videoLengthSeconds': '{n}s',
  'newproj.audioKindLabel': 'Ses tipi',
  'newproj.audioKindMusic': 'Müzik',
  'newproj.audioKindSpeech': 'Konuşma / TTS',
  'newproj.audioKindSfx': 'Ses efekti',
  'newproj.audioDurationLabel': 'Süre',
  'newproj.audioDurationSeconds': '{n}s',
  'newproj.voiceLabel': 'Ses',
  'newproj.voicePlaceholder': 'Sağlayıcı ses kimliği, opsiyonel',
  'newproj.connectorsLabel': 'Bağlayıcılar',
  'newproj.connectorsHint': 'Bu artefaktın veri çekebileceği kaynaklar.',
  'newproj.connectorsEmptyTitle': 'Yapılandırılmış bağlayıcı yok',
  'newproj.connectorsEmptyBody': 'Canlı artefaktın yer tutucular yerine gerçek verileri kullanması için bir veri kaynağı bağlayın.',
  'newproj.connectorsEmptyCta': 'Bağlayıcıları ayarla →',
  'newproj.connectorsLoading': 'Bağlayıcılar yükleniyor…',
  'newproj.connectorsCountOne': '{n} bağlı',
  'newproj.connectorsCountMany': '{n} bağlı',
  'newproj.connectorsManage': 'Yönet',
  'newproj.promptTemplateLabel': 'Referans şablon',
  'newproj.promptTemplateNoneTitle': 'Hiçbiri — kendin yaz',
  'newproj.promptTemplateNoneSub': 'Galeriyi atla, kendi brief’ini açıkla',
  'newproj.promptTemplateRefSub': 'Referans şablon',
  'newproj.promptTemplateSearch': 'Şablon ara…',
  'newproj.promptTemplateEmpty': 'Bu yüzey için henüz şablon yüklenmedi.',
  'newproj.promptTemplateBodyLabel': 'İstem (istediğin gibi düzenleyebilirsin)',
  'newproj.promptTemplateOptimizeHint':
    'İstediğin her şeyi düzenle — değişikliklerin ajan brief’ine taşınır.',
  'newproj.promptTemplateBodyEmpty': 'Gövde boş — ajana şablon referansı gitmeyecek.',

  'newproj.deleteTemplateTitle': 'Şablonu sil',
  'newproj.deleteTemplateConfirm': '"{name}" silinsin mi? Bu işlem geri alınamaz.',
  'newproj.deleteTemplateConfirmCta': 'Şablonu sil',
  'newproj.deleteTemplateError':
    'Bu şablon silinemedi. Lütfen tekrar deneyin.',
  'designs.subRecent': 'Yakında',
  'designs.subYours': 'Tasarımların',
  'designs.filterAria': 'Projeleri filtrele',
  'designs.searchPlaceholder': 'Ara…',
  'designs.emptyNoProjects': 'Henüz proje yok. Sol taraftan yeni bir tane oluşturun.',
  'designs.emptyNoMatch': 'Hiçbir proje aramanızla örtüşmedi.',
  'designs.deleteTitle': 'Projeyi sil',
  'designs.deleteConfirm': '"{name}"’i sil?',
  'designs.cardFreeform': 'serbest stil',
  'designs.status.notStarted': 'başlamadı',
  'designs.status.queued': 'Sırada',
  'designs.status.running': 'Çalışıyor',
  'designs.status.awaitingInput': 'Girdi gerekli',
  'designs.status.succeeded': 'Tamamlandı',
  'designs.status.published': 'Yayımlandı',
  'designs.status.failed': 'Başarısız',
  'designs.status.canceled': 'İptal edildi',
  'designs.viewToggleAria': 'Görüntüleme modu',
  'designs.viewGrid': 'Izgara görünümü',
  'designs.viewKanban': 'Tahta görünümü',
  'designs.kanbanEmptyColumn': 'Tasarım yok',
  'designs.deleteAria': '{name} projesini sil',
  'designs.menuMore': 'More actions',
  'designs.menuRename': 'Rename',
  'designs.menuDelete': 'Delete',
  'designs.renamePrompt': 'New name for "{name}"',
  'designs.selectMode': 'Select',
  'designs.cancelSelect': 'Cancel',
  'designs.deleteSelected': 'Delete selected',
  'designs.selectedCount': '{n} selected',
  'designs.deleteSelectedConfirm': 'Delete {n} project(s)?',
  'designs.deleteSelectedSuccess': '{n} project(s) deleted successfully.',
  'designs.deleteSelectedPartial': 'Deleted {deleted} project(s); {failed} failed.',
  'designs.tagPrototype': 'Prototype',
  'designs.tagLiveArtifact': 'Live Artifact',
  'designs.tagSlide': 'Slide',
  'designs.tagMedia': 'Media',
  'designs.renameTitle': 'Rename project',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Cancel',

  'examples.typeLabel': 'Tip',
  'examples.surfaceLabel': 'Yüzey',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': 'Görsel',
  'examples.surfaceVideo': 'Video',
  'examples.surfaceAudio': 'Ses',
  'examples.scenarioLabel': 'Senaryo',
  'examples.modeAll': 'Tümü',
  'examples.modePrototypeDesktop': 'Prototipler · Masaüstü',
  'examples.modePrototypeMobile': 'Prototipler · Mobil',
  'examples.modeDeck': 'Slaytlar',
  'examples.modeDocument': 'Doküman & şablonlar',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'Canlı',
  'examples.scenarioGeneral': 'Genel',
  'examples.scenarioEngineering': 'Mühendislik',
  'examples.scenarioProduct': 'Ürün',
  'examples.scenarioDesign': 'Tasarım',
  'examples.scenarioMarketing': 'Pazarlama',
  'examples.scenarioSales': 'Satış',
  'examples.scenarioFinance': 'Finans',
  'examples.scenarioHr': 'İnsan Kaynakları',
  'examples.scenarioOperations': 'Operasyonlar',
  'examples.scenarioSupport': 'Destek',
  'examples.scenarioLegal': 'Yasal',
  'examples.scenarioEducation': 'Eğitim',
  'examples.scenarioPersonal': 'Şahsi',
  'examples.emptyNoSkills': 'Yetenekler mevcut değil. Arka plan servisi çalışıyor mu?',
  'examples.searchPlaceholder': 'Örnek ara…',
  'examples.searchAria': 'Örnekleri ada göre ara',
  'examples.emptyNoMatch': 'Hiçbir örnek bu filtrelere uymuyor.',
  'examples.openPreview': '⤢ Önizlemeyi aç',
  'examples.loadingPreview': 'Önizleme yükleniyor…',
  'examples.hoverPreview': 'Önizlemek için fareyi üzerine getirin',
  'examples.usePrompt': 'Bu istemi kullan',
  'examples.previewModalTitle': 'Tam önizlemeyi aç (modal)',
  'examples.shareTitle': 'Bu örneği paylaş',
  'examples.shareLoadFirst': 'önizlemek için önce fareyi üzerine getirin',
  'examples.unavailablePlaceholder': 'Birlikte gelen {kind} önizlemesi yok — ayrıntılar için aç',
  'examples.shareUnavailable': 'Paylaşılacak {kind} önizlemesi gelmiyor',
  'examples.shareMenu': 'Paylaş ▾',
  'examples.exportPdfAllSlides': 'PDF olarak dışa aktar (tüm slaytlar)',
  'examples.exportPptxLocked': 'PPTX olarak dışa aktar… (Önce şablon açın)',
  'examples.tagSlideDeck': 'Slayt gösterisi',
  'examples.tagTemplate': 'Şablon',
  'examples.tagDesignSystem': 'Tasarım sistemi',
  'examples.tagMobilePrototype': 'Mobil prototip',
  'examples.tagDesktopPrototype': 'Masaüstü prototip',
  'examples.tagImage': 'Görsel',
  'examples.tagVideo': 'Video',
  'examples.tagAudio': 'Ses',
  'examples.previewLabel': 'Önizleme',

  'ds.surfaceLabel': 'Yüzey',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': 'Image',
  'ds.surfaceVideo': 'Video',
  'ds.surfaceAudio': 'Ses',
  'ds.searchPlaceholder': 'Tasarım sistemleri ara…',
  'ds.emptyNoMatch': 'Hiçbir tasarım sistemi aramanızla örtüşmedi.',
  'ds.badgeDefault': 'VARSAYILAN',
  'ds.preview': 'Önizleme',
  'ds.previewTitle': 'Tasarım sistemini önizle',
  'ds.categoryAll': 'Tümü',
  'ds.categoryUncategorized': 'Kategorilendirilmemiş',
  'ds.showcase': 'Tanıtım',
  'ds.tokens': 'Tokenler',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'DESIGN.md yükleniyor…',

  'avatar.title': 'Hesap & ayarlar',
  'avatar.localCli': 'Yerel CLI',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'Yerel CLI’ı kullan',
  'avatar.useApi': 'API · BYOK kullan',
  'avatar.codeAgent': 'Kod ajanı',
  'avatar.rescan': 'PATH’ı yeniden tara',
  'avatar.settings': 'Ayarlar',
  'avatar.backToProjects': 'Projelere dön',
  'avatar.metaActive': 'aktif',
  'avatar.metaOffline': 'çevrim dışı',
  'avatar.metaSelected': 'seçildi',
  'avatar.noAgentSelected': 'ajan seçilmedi',
  'avatar.modelSection': 'Model',
  'avatar.modelLabel': 'Model',
  'avatar.reasoningLabel': 'Akıl yürütme',
  'avatar.customSuffix': '(özel)',

  'inlineSwitcher.chipTitle': 'CLI / modeli değiştir',
  'inlineSwitcher.chipCli': 'Yerel CLI',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'varsayılan',
  'inlineSwitcher.noAgent': 'ajan yok',
  'inlineSwitcher.modeLabel': 'Mod',
  'inlineSwitcher.agentLabel': 'Ajan',
  'inlineSwitcher.providerLabel': 'Sağlayıcı',
  'inlineSwitcher.modelLabel': 'Model',
  'inlineSwitcher.useCli': 'Yerel CLI kullan',
  'inlineSwitcher.useByok': 'Kendi API anahtarını kullan',
  'inlineSwitcher.daemonOffline': 'Daemon çevrimdışı — ayarları aç',
  'inlineSwitcher.noAgentsDetected': "PATH'te CLI bulunamadı",
  'inlineSwitcher.openSettingsForModel': 'Sağlayıcıyı Ayarlardan yapılandırın',
  'inlineSwitcher.missingApiKey': 'API anahtarı yok — Ayarlardan ekleyin.',
  'inlineSwitcher.openFullSettings': 'Yürütme ayarlarını aç',
  'inlineSwitcher.customSuffix': '(özel)',

  'project.backToProjects': 'Projelere dön',
  'project.metaFreeform': 'serbest stil',
  'project.resizeChatPanel': 'Sohbet panelini yeniden boyutlandır',
  'project.instructionsActive': 'Etkin — her mesaja eklenir',
  'chat.tabChat': 'Sohbet',
  'chat.tabComments': 'Yorumlar',
  'chat.commentsSoon': 'Yorumlar — yakında',
  'chat.comments.attached': 'Attached to chat',
  'chat.comments.emptyAttached': 'No comments attached.',
  'chat.comments.saved': 'Saved comments',
  'chat.comments.emptySaved': 'No saved comments.',
  'chat.comments.add': 'Add',
  'chat.comments.addAll': 'Add all',
  'chat.comments.remove': 'Remove',
  'chat.comments.placeholder': 'Comment on this element…',
  'chat.comments.addSend': 'Add & send',
  'chat.comments.updateSend': 'Update & send',
  'chat.comments.removeAttachment': 'Remove comment attachment',
  'chat.comments.removeAttachmentAria': 'Remove comment attachment for {name}',
  'chat.comments.comment': 'Comment',
  'chat.comments.sendToChat': 'Send to chat',
  'chat.comments.sending': 'Sending…',
  'chat.comments.edit': 'Edit',
  'chat.comments.select': 'Select',
  'chat.comments.deselect': 'Deselect',
  'chat.comments.nSelected': '{n} selected',
  'chat.comments.pin': 'Pin',
  'chat.comments.addNote': 'Add note',
  'chat.comments.savedToast': 'Comment saved',
  'chat.comments.pinSavedToast': 'Pin saved',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} captured items',
  'chat.comments.clear': 'Clear',
  'chat.conversationsTitle': 'Konuşmalar',
  'chat.conversationsAria': 'Konuşma geçmişi',
  'chat.newConversation': 'Yeni konuşma',
  'chat.newConversationsTitle': 'Yeni Konuşma',
  'chat.conversationsHeading': 'Konuşmalar',
  'chat.new': 'Yeni',
  'chat.emptyConversations': 'Henüz konuşma yok.',
  'chat.deleteConversation': 'Konuşmayı sil',
  'chat.renameConversationLabel': '"{title}" adını değiştir',
  'chat.deleteConversationConfirm':
    '"{title}"’ı sil? Bu mesajları silecektir.',
  'chat.untitledConversation': 'Başlıksız konuşma',
  'chat.startTitle': 'Bir konuşma başlat',
  'chat.startHint': "Oluşturmak istediğiniz şeyi açıklayın veya bu örneklerden biriyle başlayın:",
  'chat.fillInputTitle': 'İstemi doldurmak için tıklayın',
  'chat.jumpToLatest': 'En son mesaja atla',
  'chat.scrollToLatest': 'En son mesaja kaydır',
  'chat.you': 'Sen',
  'chat.openFile': '{name}’ı aç',
  'chat.copyPrompt': 'Promptu kopyala',
  'chat.copyDone': 'Kopyalandı!',
  'chat.composerPlaceholder': "Oluşturmak istediğiniz şeyi açıklayın…",
  'chat.composerHint': "Göndermek için ⌘/Ctrl + Enter · hedef, içerik, stil ve formatı belirtin",
  'chat.cliSettingsTitle': 'CLI & model ayarları',
  'chat.cliSettingsAria': 'CLI ve model ayarlarını aç',
  'chat.attachTitle': 'Dosyaları iliştirin (veya yapıştırın / sürükleyin)',
  'chat.attachAria': 'Dosyaları iliştirin',
  'chat.importTitle': 'Kaynakları içe aktar (yakında)',
  'chat.importLabel': 'İçe aktar',
  'chat.importComingSoon': 'Yakında',
  'chat.importSoon': 'Yakında',
  'chat.importFig': 'Bir .fig dosyası yükleyin',
  'chat.importGitHub': 'GitHub bağla',
  'chat.importWeb': 'Bir web elementi',
  'chat.importFolder': 'Kod klasörünü bağlantıla',
  'chat.importSkills': 'Yetenekler ve tasarım sistemleri',
  'chat.importProject': 'Reference another project',
  'chat.linkedFolderRemoveAria': 'Bağlantılı klasörü kaldır {path}',
  'chat.linkedFolderNotFound': 'Klasör mevcut değil',
  'chat.linkedFolderAlready': 'Bu klasör zaten bağlantılı',
  'chat.linkedFolderPickError': 'Klasör seçici açılamadı',
  'chat.queuedHeader': 'Queued',
  'chat.queuedToSend': 'to Send',
  'chat.queuedEditQueuedTaskAria': 'Edit queued task',
  'chat.queuedSave': 'Save',
  'chat.queuedCancel': 'Cancel',
  'chat.queuedEdit': 'Edit',
  'chat.queuedMore': 'more queued',
  'chat.queuedFollowUpFallback': 'Queued follow-up',
  'chat.send': 'Gönder',
  'chat.stop': 'Durdur',
  'chat.removeAria': '{name}’ı sil',
  'chat.example1Title': 'Editörlük sunum dosyası',
  'chat.example1Tag': 'Magazin',
  'chat.example1Prompt':
    '10 slaytlık bir editoryal pitch deck: seed yatırım turu için fon arayan bir tasarım stüdyosu — İsviçre grid yerleşimi, büyük serif başlıklar ve kalın drop cap’ler, monospace bölüm numaraları, geniş negatif alan kullanımı ve metin yoğun slaytlarla dönüşümlü tam sayfa (full-bleed) fotoğraf slaytları. Kapak, vizyon, pazar, ürün, traction, ekip, talep, iletişim.',
  'chat.example2Title': 'SaaS analitik gösterge paneli',
  'chat.example2Tag': 'Veri',
  'chat.example2Prompt':
    'Geliştirici araçlarına yönelik bir SaaS için yoğun bir analitik gösterge paneli: haftadan haftaya değişimleri gösteren KPI şeridi, üst üste yerleştirilmiş iki çizgi grafik (MRR ve aktif çalışma alanları), kullanımın dünya ısı haritası, cohort retention grid’i, en iyi müşteriler liderlik tablosu ve gerçek zamanlı olay akışı. Karanlık tema, tabular monospace rakamlar, sparkline vurguları.',
  'chat.example3Title': 'Annual report long-scroll',
  'chat.example3Tag': 'Editoryal',
  'chat.example3Prompt':
    'İklim odaklı bir sivil toplum kuruluşu için etkileşimli bir yıllık rapor: büyük alıntı blokları, veri görselleştirmeleri (yığılmış çubuk grafikler, animasyonlu sayaçlar, proje sahalarını gösteren choropleth harita), fotoğraf geçişleri, bağışçı duvarı ve finalde bir call-to-action içeren uzun kaydırmalı editoryal yerleşim. Modern serif gövde metni, grafik etiketlerinde sans-serif, toprak tonlarında kâğıt paleti.',

  'preview.shareMenu': 'Paylaş ▾',
  'preview.openInNewTab': 'Yeni sekmede aç',
  'preview.exit': '⤓ Çık',
  'preview.fullscreen': '⤢ Tam ekran',
  'preview.closeTitle': 'Kapat (Esc)',
  'preview.loading': '{label} yükleniyor…',
  'preview.errorTitle': 'Bu örnek yüklenemedi.',
  'preview.errorBody': 'Örnek HTML\'i alınamadı. Open Design\'ın çalıştığından emin olup tekrar deneyin.',
  'preview.retry': 'Tekrar dene',
  'preview.unavailableTitle': 'Bu yetenek için birlikte gelen bir önizleme yok.',
  'preview.unavailableBody': 'Bu yetenek {kind} çıktısı üretir — bir tane oluşturmak için sohbette istemini çalıştırın.',
  'preview.showSidebar': '{label} göster',
  'preview.hideSidebar': '{label} gizle',

  'misc.savedTemplate': 'Kaydedilmiş şablonlar',
  'misc.primary': 'Birincil',
  'misc.designSystem': 'Tasarım sistemi',

  'workspace.designFiles': 'Tasarım Dosyaları',
  'workspace.closeTab': 'Sekmeyi kapat',
  'workspace.deleteFileConfirm': '"{name}"ı proje klasöründen sil?',
  'workspace.deleteSelectedFilesConfirm': 'Seçili {n} dosya proje klasöründen silinsin mi?',
  'workspace.deleteSelectedFilesPartial': '{n} dosya silinemedi.',
  'workspace.openFromDesignFiles': 'bir dosya aç',
  'workspace.designFilesLink': 'Tasarım Dosyaları',
  'workspace.loadingSketch': 'Taslak yükleniyor…',
  'designFiles.title': 'Tasarım Dosyaları',
  'designFiles.upload': 'Dosyaları yükle',
  'designFiles.pasteText': 'Metin dosyası olarak yapıştır',
  'designFiles.newSketch': 'Yeni taslak',
  'designFiles.empty': 'Eserler burada görünecek',
  'designFiles.refresh': 'Yenile',
  'designFiles.delete': 'Sil',
  'designFiles.searchPlaceholder': 'Dosyaları ara…',
  'designFiles.up': 'Yukarı',
  'designFiles.back': 'Geri',
  'designFiles.crumbs': 'proje',
  'designFiles.rowMenu': 'Sıra menüsü',
  'designFiles.openInTab': 'Sekmede aç',
  'designFiles.download': 'İndir',
  'designFiles.downloadSelected': '{n} dosyayı ZIP olarak indir',
  'designFiles.clearSelection': 'Seçimi temizle',
  'designFiles.selectPage': 'Sayfadaki tümünü seç',
  'designFiles.selectAll': 'Tümünü seç',
  'designFiles.deleteSelected': '{n} sil',
  'designFiles.dropTitle': '⤓ Dosyaları buraya sürükleyin',
  'designFiles.dropDesc':
    'Görseller, dokümanlar, referanslar, veya klasörler — ajan onları bağlam olarak kullanacak.',
  'designFiles.upload.title': 'Dosyaları yükleyin',
  'designFiles.paste.title': 'Metin dosyası olarak yapıştır',
  'designFiles.upload.label': 'Yükle',
  'designFiles.paste.label': 'Yapıştır',
  'designFiles.previewOpen': 'Aç',
  'designFiles.previewClose': 'Önizlemeyi kapat',
  'designFiles.modified': 'Düzenlendi: {time} · {size}',
  'designFiles.weeksAgo': '{n} hafta önce',
  'designFiles.groupBy': 'Grupla',
  'designFiles.groupByKind': 'Tür',
  'designFiles.groupByModified': 'Değiştirilme',
  'designFiles.expandGroup': 'Genişlet',
  'designFiles.collapseGroup': 'Daralt',
  'designFiles.sectionPages': 'Sayfalar',
  'designFiles.sectionScripts': 'Betikler',
  'designFiles.sectionImages': 'Görseller',
  'designFiles.sectionSketches': 'Taslaklar',
  'designFiles.sectionOther': 'Diğer',
  'designFiles.modifiedToday': 'Bugün',
  'designFiles.modifiedYesterday': 'Dün',
  'designFiles.modifiedPrevious7Days': 'Son 7 gün',
  'designFiles.modifiedPrevious30Days': 'Son 30 gün',
  'designFiles.modifiedOlder': 'Daha eski',
  'designFiles.showMore': '+{n} tane daha göster',
  'designFiles.kindHtml': 'HTML sayfası',
  'designFiles.kindImage': 'Görsel',
  'designFiles.kindSketch': 'Taslak',
  'designFiles.kindText': 'Metin',
  'designFiles.kindCode': 'Betil',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Doküman',
  'designFiles.kindPresentation': 'Sunum',
  'designFiles.kindSpreadsheet': 'Elektronik tablo',
  'designFiles.kindBinary': 'Binary',
  'designFiles.kindFolder': 'Klasör',
  'designFiles.folderCount': '{n} dosya',
  'designFiles.colName': 'Ad',
  'designFiles.colKind': 'Tür',
  'designFiles.colModified': 'Değiştirilme',
  'designFiles.perPage': 'Göster',
  'designFiles.all': 'Tümü',
  'designFiles.prev': 'Önceki',
  'designFiles.next': 'Sonraki',
  'designFiles.jumpToPage': 'Sayfaya git',
  'designFiles.pageInfo': '{start}–{end} / {total}',
  'quickSwitcher.placeholder': 'Dosya aç…',
  'quickSwitcher.empty': 'Bu projede dosya yok',
  'quickSwitcher.noMatches': 'Eşleşme yok',
  'quickSwitcher.navigate': 'gezin',
  'quickSwitcher.open': 'aç',
  'quickSwitcher.close': 'kapat',
  'pasteDialog.title': 'Metin yapıştır',
  'pasteDialog.hint': 'Proje klasörüne kaydedilir. Herhangi bir isim seçin.',
  'pasteDialog.fileNameLabel': 'Dosya adı',
  'pasteDialog.namePlaceholder': 'notes.txt',
  'pasteDialog.contentLabel': 'İçerik',
  'pasteDialog.contentPlaceholder': 'Herhangi bir şey yapıştırın…',
  'pasteDialog.save': 'Kaydet',
  'pasteDialog.cancel': 'İptal et',
  'sketch.save': 'Taslağı kaydet',
  'sketch.cancel': 'İptal et',
  'sketch.saving': 'Kaydediliyor…',
  'sketch.saved': 'Kaydedildi',
  'sketch.tooltipDirty': 'Kaydedilmemiş değişiklikler',
  'sketch.tooltipClean': 'Kaydedildi',
  'fileViewer.empty': 'Görüntülemek için bir dosya seçin.',
  'fileViewer.loading': 'Yükleniyor…',
  'fileViewer.exportPptx': 'PPTX olarak dışa aktar',
  'fileViewer.openInNewTab': 'Yeni sekmede aç',
  'fileViewer.copyPath': 'Yolu kopyala',
  'fileViewer.copied': 'Kopyalandı!',
  'fileViewer.share': 'Paylaş',
  'fileViewer.binaryMeta': 'Binary · {size}',
  'fileViewer.binaryNote':
    'Binary dosyası ({size} bytes). İncelemek için indirin veya diskten seçin.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Doküman',
  'fileViewer.presentationMeta': 'Sunum',
  'fileViewer.spreadsheetMeta': 'Elektronik tablo',
  'fileViewer.previewUnavailable': 'Önizleme mevcut değil. İncelemek için indirin veya diskten seçin.',
  'fileViewer.download': 'İndir',
  'fileViewer.open': 'Aç',
  'fileViewer.imageMeta': 'Görsel · {size}',
  'fileViewer.reactMeta': 'React bileşeni · {size}',
  'fileViewer.sketchMeta': 'Taslak · {size}',
  'fileViewer.markdownStreamingMeta': 'Önizleme yayınlanıyor…',
  'fileViewer.markdownErrorMeta': 'Önizleme eksik olabilir (oluşturma hatası).',
  'fileViewer.markdownStreamingStatus': 'Yayınlanıyor… kısmi markdown gösteriliyor.',
  'fileViewer.markdownErrorStatus': 'Oluşturma hatası. Son mevcut içerik gösteriliyor.',
  'fileViewer.videoMeta': 'Video · {size}',
  'fileViewer.audioMeta': 'Ses · {size}',
  'fileViewer.reload': 'Yeniden yükle',
  'fileViewer.reloadDisk': 'Diskten yeniden yükle',
  'fileViewer.copy': 'Kopyala',
  'fileViewer.copyTitle': 'Dosya içeriklerini kopyala',
  'fileViewer.saveDisabled': 'Kaydet (salt-okunur görüntüleyici)',
  'fileViewer.save': 'Kaydet',
  'fileViewer.preview': 'Önizle',
  'fileViewer.source': 'Kaynak',
  'fileViewer.tweaks': 'Düzenlemeler',
  'fileViewer.tweaksUnavailable': 'Bu artefaktta düzenleme paneli yok',
  'fileViewer.jsxModuleTitle': 'Bağımsız önizleme yok',
  'fileViewer.jsxModuleBody': 'Bu dosya başka bir sayfa tarafından yüklenen bir bileşen modülüdür.',
  'fileViewer.jsxModuleCta': 'Onu işleyen sayfayı açın:',
  'fileViewer.comment': 'Yorum',
  'fileViewer.edit': 'Düzenle',
  'fileViewer.draw': 'Çiz',
  'manualEdit.layers': "Layers",
  'manualEdit.editableCount': "{count} editable",
  'manualEdit.hiddenBadge': "Hidden",
  'manualEdit.title': "Manual editor",
  'manualEdit.selectLayer': "Select a layer",
  'manualEdit.empty': "Click an element in the preview or choose a layer.",
  'manualEdit.noEditableLayers': "No editable layers found.",
  'manualEdit.noClass': "no class",
  'manualEdit.tabsAria': "Manual edit tabs",
  'manualEdit.tabContent': "Content",
  'manualEdit.tabStyle': "Style",
  'manualEdit.tabAttributes': "Attributes",
  'manualEdit.tabHtml': "Html",
  'manualEdit.tabSource': "Source",
  'manualEdit.attributesJson': "Attributes JSON",
  'manualEdit.selectedHtml': "Selected element HTML",
  'manualEdit.fullSource': "Full artifact source",
  'manualEdit.applyContent': "Apply Content",
  'manualEdit.applyStyle': "Apply Style",
  'manualEdit.applyAttributes': "Apply Attributes",
  'manualEdit.applyHtml': "Apply HTML",
  'manualEdit.applySource': "Apply Source",
  'manualEdit.invalidAttributes': "Invalid attributes JSON.",
  'manualEdit.changes': "Changes",
  'manualEdit.undo': "Undo",
  'manualEdit.redo': "Redo",
  'manualEdit.noChanges': "No manual edits yet.",
  'manualEdit.imageUrl': "Image URL",
  'manualEdit.altText': "Alt text",
  'manualEdit.label': "Label",
  'manualEdit.text': "Text",
  'manualEdit.href': "Href",
  'manualEdit.textColor': "Text color",
  'manualEdit.background': "Background",
  'manualEdit.fontSize': "Font size",
  'manualEdit.weight': "Weight",
  'manualEdit.align': "Align",
  'manualEdit.padding': "Padding",
  'manualEdit.margin': "Margin",
  'manualEdit.radius': "Radius",
  'manualEdit.border': "Border",
  'manualEdit.width': "Width",
  'manualEdit.minHeight': "Min height",
  'fileViewer.zoomOut': 'Yakınlaş',
  'fileViewer.zoomIn': 'Uzaklaş',
  'fileViewer.resetZoom': 'Uzaklığı sıfırla',
  'fileViewer.viewportAria': 'Preview viewport',
  'fileViewer.viewportDesktop': 'Desktop',
  'fileViewer.viewportDesktopTitle': 'Full-width desktop preview',
  'fileViewer.viewportTablet': 'Tablet',
  'fileViewer.viewportTabletTitle': 'Tablet preview at 820 × 1180 (modern portrait baseline)',
  'fileViewer.viewportMobile': 'Mobile',
  'fileViewer.viewportMobileTitle': 'Mobile preview at 390 × 844',
  'fileViewer.reloadAria': 'Yeniden yükle',
  'fileViewer.previousSlide': 'Önceki slayt',
  'fileViewer.nextSlide': 'Sonraki slayt',
  'fileViewer.slideNavAria': 'Slayt hareketi',
  'fileViewer.present': 'Sun',
  'fileViewer.presentInTab': 'Bu pencerede sun',
  'fileViewer.presentFullscreen': 'Tam ekran',
  'fileViewer.presentNewTab': 'Yeni sekme',
  'fileViewer.exitPresentation': 'Sunumdan ayrıl',
  'fileViewer.shareLabel': "Paylaş",
  'fileViewer.exportPdf': 'PDF olarak dışa aktar',
  'fileViewer.exportPdfAllSlides': 'PDF olarak dışa aktar (tüm slaytlar)',
  'fileViewer.exportPptxBusy': 'Güncel sıranın bitmesini bekleyin.',
  'fileViewer.exportPptxHint':
    'Bu tasarımı PPTX’e dönüştürmesi için ajana bir istek yollayın.',
  'fileViewer.exportPptxNa': 'PPTX dışa aktarma burada mevcut değil.',
  'fileViewer.exportZip': 'ZIP olarak indir',
  'fileViewer.exportHtml': 'Tekil HTML olarak dışa aktar',
  'fileViewer.exportMd': 'Markdown olarak dışa aktar',
  'fileViewer.exportImage': 'Görsel olarak dışa aktar',
  'fileViewer.exportImageFailed': 'Görsel yakalama başarısız oldu. Lütfen tekrar deneyin veya tarayıcınızın ekran görüntüsü aracını kullanın.',
  'fileViewer.exportJsx': 'JSX olarak dışa aktar',
  'fileViewer.exportReactHtml': 'Önizlemeyi HTML olarak dışa aktar',
  'fileViewer.saveAsTemplate': 'Şablon olarak kaydet…',
  'fileViewer.savingTemplate': 'Şablon kaydediliyor…',
  'fileViewer.savedTemplate': '"{name}" olarak kaydedildi',
  'fileViewer.savedTemplateFail': 'Şablon olarak kaydedilemedi — yeniden deneyin.',
  'fileViewer.templateNamePrompt': 'Şablon ismi',
  'fileViewer.templateNameDefault': 'Başlıksız şablon',
  'fileViewer.templateDescPrompt':
    'Kısa açıklama (opsiyonel — bu şablonu kullanışlı yapan ne?)',
  'fileViewer.deployToVercel': 'Vercel’e yayınla',
  'fileViewer.redeployToVercel': 'Yeniden yayınla',
  'fileViewer.deployingToVercel': 'Vercel’e yayınlanıyor…',
  'fileViewer.deployProviderLabel': 'Yayınlama sağlayıcısı',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployToProvider': '{provider}’e yayınla',
  'fileViewer.redeployToProvider': '{provider}’e yeniden yayınla',
  'fileViewer.deployingToProvider': '{provider}’e yayınlanıyor…',
  'fileViewer.preparingPublicLink': 'Herkese açık bağlantı hazırlanıyor…',
  'fileViewer.copyDeployLink': 'Bağlantıyı kopyala',
    'fileViewer.deployModalTitle': 'Yayınla',
  'fileViewer.deployModalSubtitle': 'Bu HTML önizlemesini seçilen sağlayıcı hesabıyla yayınlayın.',
  'fileViewer.vercelToken': 'Vercel tokeni',
  'fileViewer.vercelTokenGetLink': 'Vercel tokenini al',
  'fileViewer.vercelTokenPlaceholder': 'Vercel tokeninizi yapıştırın',
  'fileViewer.vercelTokenReuseHint': 'Kaydedilmiş token kullanılacak. Değiştirmek için yeni bir token girin.',
  'fileViewer.vercelTokenRequired': 'Önce bir Vercel tokeni girin ve kaydedin.',
  'fileViewer.cloudflareApiToken': 'Cloudflare API tokeni',
  'fileViewer.cloudflareApiTokenGetLink': 'Cloudflare API tokenini al',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Cloudflare API tokeninizi yapıştırın',
  'fileViewer.cloudflareApiTokenReuseHint': 'Kaydedilmiş Cloudflare API tokeni kullanılacak. Değiştirmek için yeni bir token girin.',
  'fileViewer.cloudflareApiTokenRequired': 'Önce bir Cloudflare API tokeni girin ve kaydedin.',
  'fileViewer.cloudflareApiTokenScopeHint': 'Pages Edit is required for deploys. Zone Read is required to list domains. DNS Edit is only needed when binding a custom domain.',
  'fileViewer.vercelTeamId': 'Takım ID',
  'fileViewer.vercelTeamSlug': 'Takım slug’ı',
  'fileViewer.cloudflareAccountId': 'Hesap ID',
  'fileViewer.cloudflareAccountIdHint': 'Zorunlu. Hesap ID’sini Cloudflare panosunda bulabilirsiniz.',
  'fileViewer.cloudflareAccountIdRequired': 'Önce Cloudflare Account ID girin ve kaydedin.',
  'fileViewer.cloudflareZoneLabel': 'Domain',
  'fileViewer.cloudflareZonePlaceholder': 'Save Cloudflare settings to load domains',
  'fileViewer.cloudflareZoneRequired': 'Select a Cloudflare domain first.',
  'fileViewer.cloudflareZonesLoading': 'Loading Cloudflare domains…',
  'fileViewer.cloudflareZonesRefresh': 'Refresh domains',
  'fileViewer.cloudflareZonesLoadFailed': 'Could not load Cloudflare domains.',
  'fileViewer.cloudflareZonesEmpty': 'No active full Cloudflare domains were found for this account.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Subdomain prefix',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Use one DNS label only: lowercase letters, numbers, and hyphens.',
  'fileViewer.cloudflareHostnamePreview': 'Custom domain preview: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Optional: choose a Cloudflare domain and prefix to bind a custom subdomain. pages.dev will still be available.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'pages.dev URL',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Custom domain',
  'fileViewer.optional': 'Opsiyonel',
  'fileViewer.vercelPreviewOnly': 'Yayınlanmış içerikler şimdilik yalnızca önizlenebilir.',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages yayınları Direct Upload kullanır.',
  'fileViewer.savingConfig': 'Kaydediliyor…',
  'fileViewer.deployConfigSaveFailed': 'Vercel ayarları kaydedilemedi.',
  'fileViewer.deployFailed': 'Yayınlama başarısız oldu. Vercel ayarlarınızı kontrol edin ve yeniden deneyin.',
  'fileViewer.deployProviderConfigSaveFailed': '{provider} ayarları kaydedilemedi.',
  'fileViewer.deployProviderFailed': '{provider} yayını başarısız oldu. Ayarları kontrol edip yeniden deneyin.',
  'fileViewer.deployResultLabel': 'Yayınlanmış URL',
  'fileViewer.deployLinkReady': 'Hazır',
  'fileViewer.deployLinkPreparingLabel': 'Herkese açık link bekleniyor',
  'fileViewer.deployLinkDelayed': 'Site yayınlandı. Sağlayıcı herkese açık bağlantıyı hâlâ hazırlıyor.',
  'fileViewer.deployLinkFailed': 'Özel alan adı başarısız',
  'fileViewer.deployLinkProtectedLabel': 'Yayın koruması etkin',
  'fileViewer.deployLinkProtected': 'Site yayınlandı, ancak bu önizleme bağlantısı kimlik doğrulaması istiyor. Deployment Protection’ı kapatın veya özel alan adı kullanın.',
  'fileViewer.retryLink': 'Şimdi yeniden dene',

  'questionForm.submit': 'Gönder',
  'questionForm.skip': 'Atla',
  'questionForm.locked': 'Cevaplandı',

  'conv.switch': 'Konuşmayı değiştir',
  'conv.label': 'Konuşma',
  'conv.heading': 'Konuşmalar',
  'conv.new': '+ Yeni',
  'conv.empty': 'Henüz konuşma yok.',
  'conv.untitled': 'Başlıksız konuşma',
  'conv.renameTooltip': 'Yeniden adlandırmak için çift tıklayın',
  'conv.delete': 'Konuşmayı sil',
  'conv.deleteConfirm': '"{title}"ı sil? Bu mesajları silecektir.',

  'agentPicker.label': 'Ajan',
  'agentPicker.modeChoose': 'Yürütme modunu seç',
  'agentPicker.localCli': 'Yerel CLI',
  'agentPicker.daemonOff': 'Arka plan servisi kapalı',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'Tespit edilmiş bir kod ajanı CLI’ı seçin',
  'agentPicker.noAgents': 'PATH’te ajan yok',
  'agentPicker.notInstalled': 'kurulmadı',
  'agentPicker.rescan': 'Ajanlar için yerel PATH’ı yeniden tara',

  'tool.openInTab': '{name}’ı bir sekmede aç ',
  'tool.open': 'aç',
  'tool.todos': 'Yapılacaklar',
  'tool.askQuestion': 'Soru',
  'tool.askQuestionSubmit': 'Gönder',
  'tool.askQuestionPending': 'Cevabınız bekleniyor',
  'tool.askQuestionAnswered': 'Cevaplandı',
  'tool.todosExpand': 'Görevleri göster',
  'tool.todosCollapse': 'Görevleri gizle',
  'tool.todosDone': 'Tamam',
  'tool.todosDismiss': 'Görev listesini kapat',
  'tool.write': 'Yaz',
  'tool.edit': 'Düzenle',
  'tool.read': 'Oku',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Fetch',
  'tool.search': 'Ara',
  'tool.lines': '{n} satır',
  'tool.changeSingular': 'değişiklik',
  'tool.changePlural': 'değişiklikler',
  'tool.in': '{path} yolunda',
  'tool.hide': 'sakla',
  'tool.output': 'çıktı',
  'tool.running': 'çalışıyor…',
  'tool.error': 'hata',
  'tool.done': 'bitti',

  'assistant.role': 'Asistan',
  'assistant.workingLabel': 'Çalışıyor',
  'assistant.doneLabel': 'Bitti',
  'assistant.feedbackPrompt': 'Geri bildirim',
  'assistant.feedbackPositive': 'Yararlı',
  'assistant.feedbackNegative': 'Yararlı değil',
  'assistant.feedbackReasonTitle': 'Tell us why',
  'assistant.feedbackReasonPositiveMatched': 'Understood my request',
  'assistant.feedbackReasonPositiveVisual': 'Looks good',
  'assistant.feedbackReasonPositiveUseful': 'Useful structure',
  'assistant.feedbackReasonPositiveEasy': 'Easy to keep editing',
  'assistant.feedbackReasonPositiveDesignSystem': 'Followed the design system',
  'assistant.feedbackReasonNegativeMissed': 'Missed my request',
  'assistant.feedbackReasonNegativeVisual': 'Visual quality needs work',
  'assistant.feedbackReasonNegativeIncomplete': 'Incomplete output',
  'assistant.feedbackReasonNegativeHard': 'Hard to use',
  'assistant.feedbackReasonNegativeDesignSystem': 'Did not follow the design system',
  'assistant.feedbackReasonOther': 'Other',
  'assistant.feedbackReasonPlaceholder': 'Add a short note...',
  'assistant.feedbackReasonSubmit': 'Submit',
  'assistant.emptyResponseLabel': 'No output',
  'assistant.emptyResponseMessage': 'The provider ended the request without returning text or an artifact. Try another model or provider, check quota, or retry.',
  'assistant.unfinishedLabel': 'Bitmemiş işlerle durduruldu',
  'assistant.unfinishedSummary': '{n} görev kaldı',
  'assistant.unfinishedMore': '+{n} daha',
  'assistant.continueRemaining': 'Kalan görevleri sürdür',
  'assistant.outTokens': '{n} çıktı',
  'assistant.producedFiles': 'Bu çalışmadan dosyalar',
  'assistant.openFile': 'Aç',
  'assistant.downloadFile': 'İndir',
  'assistant.thinking': 'Düşünüyor',
  'assistant.systemReminder': 'Sistem hatırlatıcısı',
  'assistant.waitingFirstOutput': 'İlk girdi için bekleniyor',
  'assistant.statusBootingAgent': 'Ajan başlatılıyor',
  'assistant.statusStarting': 'Başlıyor',
  'assistant.statusRequesting': 'İstek gönderiliyor',
  'assistant.statusThinking': 'Düşünüyor',
  'assistant.statusStreaming': 'Yayınlıyor',
  'assistant.slowHint':
    'Normalden uzun sürüyor. Form normalde 5–10 saniye içinde görünür — Durabilir ve cümleninizi yeniden gönderebilirsiniz.',
  'assistant.verbEditing': 'Düzenliyor',
  'assistant.verbWriting': 'Yazıyor',
  'assistant.verbReading': 'Okuyor',
  'assistant.verbSearching': 'Arıyor',
  'assistant.verbRunning': 'Çalıştırıyor',
  'assistant.verbTodos': 'Yapılacaklar',
  'assistant.verbFetching': 'Getiriyor',
  'assistant.verbCalling': 'Çağırıyor',

  'qf.answered': 'cevapladı',
  'qf.choose': 'Se.…',
  'qf.required': 'gerekli',
  'qf.lockedSubmitted':
    'Cevaplar gönderildi — ajan bunları oturum sonuna kadar kullanıyor.',
  'qf.lockedPrev': 'Bu form önceki bir çalışmadan.',
  'qf.hint':
    "Uyanı seçin. Önemsemediğiniz opsiyonel alanları atlayın — ajan mantıklı varsayılan değerler kullanacak.",
  'qf.submitDefault': 'Cevapları gönder',
  'qf.submitDisabledTitle': 'Önce gerekli alanları doldurun',
  'qf.submitTitle': 'Cevapları gönder',
  'qf.cardSelected': 'seçildi',
  'qf.cardRefs': 'Referanslar:',
  'qf.cardSampleText': 'Pijamalı hasta yağız şoföre çabucak güvendi · 0123',

  'sketch.toolSelect': 'Seç (işlem yok)',
  'sketch.toolPen': 'Kalem',
  'sketch.toolText': 'Metin',
  'sketch.toolRect': 'Dörtgen',
  'sketch.toolArrow': 'Ok',
  'sketch.toolEraser': 'Silgi',
  'sketch.color': 'Renk',
  'sketch.strokeSize': 'Fırça boyutu',
  'sketch.undo': 'Geri al',
  'sketch.clear': 'Temizle',
  'sketch.close': 'Kapat',
  'sketch.closeConfirm': 'Eskizi kapatıp kaydedilmemiş değişiklikleri silelim mi?',
  'sketch.textPrompt': 'Metin:',
  'sketch.textModalTitle': 'Metin ekle',

  'pet.title': 'Evcil Dostlar',
  'pet.tabBuiltIn': 'Yerleşik',
  'pet.tabBuiltInHint': 'Open Design ile gelen seçili dostlar — birini seç ve sahiplen.',
  'pet.builtInEmpty': 'Hazır petler şu an kullanılamıyor. Daemon tekrar çevrimiçi olduğunda Topluluk sekmesini yenile.',
  'pet.tabCustom': 'Özel',
  'pet.tabCustomHint': 'Ad, glif, renk veya sprite\'ını kendin belirle.',
  'pet.tabCommunity': 'Topluluk',
  'pet.tabCommunityHint': 'Codex\'te yumurtadan çıkan dostlar — sahiplen ya da yapay zekâ ile yeni bir tane üret.',
  'pet.tabsAria': 'Evcil dost kaynağı',
  'pet.subtitle': 'Çalışma alanının üstünde süzülen küçük bir dost edin.',
  'pet.navTitle': 'Evcil Dostlar',
  'pet.navHint': 'Sahiplen veya özelleştir',
  'pet.adopt': 'Sahiplen',
  'pet.adoptedBadge': 'Sahiplenildi',
  'pet.adoptCallout': 'Bir evcil dost sahiplen',
  'pet.changePet': 'Dostu değiştir',
  'pet.wake': 'Uyandır',
  'pet.tuck': 'Sakla',
  'pet.wakeTitle': 'Dostu uyandır — kayan paneli göster.',
  'pet.tuckTitle': 'Dostu sakla — kayan paneli gizle.',
  'pet.settingsTitle': 'Evcil dost ayarlarını aç',
  'pet.useCustom': 'Kendi dostumu kullan',
  'pet.customTitle': 'Kendin oluştur',
  'pet.customHint': 'Bir ad, simge ve vurgu rengi seç — panel anında güncellenir.',
  'pet.customGreetingPlaceholder': 'Dostundan bir selam…',
  'pet.fieldName': 'Ad',
  'pet.fieldGlyph': 'Simge',
  'pet.fieldGlyphHint': 'Tek bir emoji en iyisidir (ör. 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Selamlama',
  'pet.fieldAccent': 'Vurgu rengi',
  'pet.fieldAccentCustom': 'Özel renk',
  'pet.fieldAccentDefault': 'Varsayılan vurgu rengi',
  'pet.overlayAria': 'Evcil dost yoldaş',
  'pet.spriteAria': '{name} — taşımak için sürükle, sohbet için tıkla',
  'pet.spriteTitle': '{name} merhaba diyor! Sohbet için tıkla.',
  'pet.composerTitle': 'Evcil Dostlar — uyandır, sakla veya seç',
  'pet.composerMenuTitle': 'Evcil Dostlar',
  'pet.composerMenuHint': 'ipucu: değiştirmek için /pet yaz',
  'pet.composerOpenSettings': 'Evcil Hayvanları Yönet',
  'pet.welcomeTeaserTitle': 'Bir evcil dost sahiplen',
  'pet.welcomeTeaserBody': 'Çalışma alanın üstünde süzülen küçük bir yoldaş.',
  'pet.welcomeTeaserCta': 'Birini seç',
  'pet.imageUpload': 'Sprite yükle',
  'pet.imageReplace': 'Sprite değiştir',
  'pet.imageRemove': 'Emoji kullan',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF veya SVG. Spritesheet? Yatay bir şerit yükle ve frame sayısını ayarla.',
  'pet.imageHintActive': 'Sprite gösteriliyor. Frame sayısını > 1 yaparak yatay spritesheeti hareket ettir.',
  'pet.fieldFrames': 'Frame',
  'pet.fieldFramesHint': '1 = statik. > 1 = yatay spritesheet.',
  'pet.fieldFps': 'Hız (fps)',
  'pet.fieldFpsHint': 'Frame değişim hızı.',
  'pet.atlasImport': 'Codex sprite\'ı içe aktar',
  'pet.atlasImportTitle': 'hatch-pet 8x9 / 192x208 atlasını (PNG veya WebP) içe aktarın.',
  'pet.atlasPickerTitle': 'Bir animasyon satırı seçin',
  'pet.atlasPickerHint': 'Codex evcilleri 9 animasyon satırı ile gelir. Varsayılan olarak tüm atlası saklarız; böylece evcil hayvan üzerine gelmede, sürükleme yönünde ve uzun boşta kalmada satır değiştirir. Tek bir döngüye de sabitleyebilirsiniz.',
  'pet.atlasCancel': 'Atlası bırak',
  'pet.atlasAdopt': 'Bu satıra sabitle',
  'pet.atlasAdoptFull': 'Tüm atlası kullan (animasyonlu)',
  'pet.atlasAdoptFullTitle': 'Tüm satırları koruyun; böylece evcil hayvan üzerine gelmeye, sürükleme yönüne ve uzun boşta kalmaya tepki verir.',
  'pet.atlasAdoptRowTitle': 'Yalnızca vurgulanan satırı tek döngülü bir şerite kesin.',
  'pet.atlasActiveHint': 'Animasyonlu atlas etkin — evcil hayvan etkileşiminize (üzerine gelme, sürükleme, boşta kalma) göre bir satır seçer.',
  'pet.atlasRow.idle': 'Boşta',
  'pet.atlasRow.running-right': 'Sağa koş',
  'pet.atlasRow.running-left': 'Sola koş',
  'pet.atlasRow.waving': 'El sallama',
  'pet.atlasRow.jumping': 'Zıplama',
  'pet.atlasRow.failed': 'Başarısız',
  'pet.atlasRow.waiting': 'Bekleme',
  'pet.atlasRow.running': 'Koşu',
  'pet.atlasRow.review': 'İnceleme',
  'pet.hatchTitle': 'AI ile yeni pet kuluçkala',
  'pet.hatchHint': 'Sohbette gömülü hatch-pet skill\'ini kullanarak Codex tarzı bir spritesheet üretin, ardından buraya içe aktarın.',
  'pet.hatchConcept': 'Pet konsepti (opsiyonel)',
  'pet.hatchConceptPlaceholder': 'örn. rahat bir kazak giyen küçük piksel-art shiba',
  'pet.hatchCopy': 'Prompt\'u kopyala',
  'pet.hatchCopied': 'Kopyalandı!',
  'pet.hatchFoot': 'Skill petinizi kaydettiğinde geri dönüp "Codex sprite\'ı içe aktar" düğmesine basın.',
  'pet.slashPopoverAria': 'Slash komutları',
  'pet.slashPopoverTitle': 'Komutlar',
  'pet.slashPopoverHint': '↑↓ gez · enter seç · esc kapat',
  'pet.slashPet': 'Peti aç/kapat, evlat edin veya ayarları aç.',
  'pet.slashPetWake': 'Yüzen peti uyandır.',
  'pet.slashPetTuck': 'Peti şimdilik sakla.',
  'pet.slashHatch': 'hatch-pet skill\'i ile bir Codex peti üret.',
  'pet.slashHatchArg': '<konsept>',
  'pet.slashSearch': 'OD research komutuyla web araması yap.',
  'pet.slashSearchArg': '<sorgu>',
  'pet.codexTitle': 'Yeni kuluçkalananlar',
  'pet.codexSubtitle': 'hatch-pet skill\'inin paketlediği petler tek tıkla evlat edinmek için burada görünür.',
  'pet.codexSubtitleWithDir': 'hatch-pet paketleri için {dir} taranıyor.',
  'pet.codexEmpty': 'Henüz kuluçkalanan pet yok. Sohbette /hatch yazarak bir tane üretin.',
  'pet.codexLoading': 'Kuluçkalanan petler aranıyor…',
  'pet.codexRefresh': 'Yenile',
  'pet.codexAdopt': 'Evlat edin',
  'pet.codexAdopting': 'Evlat ediniyor…',
  'pet.communitySync': 'Topluluk petlerini indir',
  'pet.communitySyncing': 'İndiriliyor…',
  'pet.communitySyncTitle': 'Codex Pet Share + j20 Hatchery üzerindeki en yeni petleri ~/.codex/pets/ altına eşitle.',
  'pet.communitySyncDone': '{wrote} yeni pet eşitlendi (toplam {total}).',
  'pet.communitySyncFailed': 'Eşitleme başarısız: {error}',
  'pet.codexBundled': 'Yerleşik',
  'pet.codexBundledTitle': 'Open Design ile birlikte gelir — indirme gerekmez.',

  'settings.notifications': 'Bildirimler',
  'settings.notificationsHint': 'Görev tamamlandığında ses ve masaüstü bildirimi',
  'settings.notifyCompletionSound': 'Tamamlanma sesi',
  'settings.notifyCompletionSoundHint': 'Bir tur sona erdiğinde çalar. Varsayılan olarak kapalı.',
  'settings.notifySuccessSound': 'Başarı sesi',
  'settings.notifyFailureSound': 'Hata sesi',
  'settings.notifyDesktop': 'Masaüstü bildirimi',
  'settings.notifyDesktopHint': 'Pencere etkin değilken gönderilir.',
  'settings.notifyDesktopBlocked': 'Tarayıcı bildirimleri engelledi. Site ayarlarından izin verin.',
  'settings.notifyDesktopUnsupported': 'Bu ortamda masaüstü bildirimleri kullanılamıyor.',
  'settings.notifyTest': 'Test gönder',
  'settings.notifyTestSent': 'Test bildirimi gönderildi. Banner görünmezse tarayıcı ve sistem bildirim ayarlarını kontrol edin.',
  'settings.notifyTestFailed': 'Bildirim çağrısı başarısız oldu. Tarayıcı ve sistem bildirim ayarlarını kontrol edin.',
  'settings.notifySoundDing': 'Çın',
  'settings.notifySoundChime': 'Çıngırak',
  'settings.notifySoundTwoToneUp': 'Yükselen iki ton',
  'settings.notifySoundPluck': 'Tıngırtı',
  'settings.notifySoundBuzz': 'Vızıltı',
  'settings.notifySoundTwoToneDown': 'Alçalan iki ton',
  'settings.notifySoundThud': 'Boğuk vuruş',
  'settings.skills': 'Yetenekler',
  'settings.skillsHint': 'Aracının görev sırasında çağırabileceği işlevsel yetenekler',
  'settings.skillsNew': 'Yeni yetenek',
  'settings.skillsEmpty': 'Soldan bir yetenek seçin veya yeni bir yetenek oluşturun.',
  'settings.skillsEdit': 'Düzenle',
  'settings.skillsDelete': 'Sil',
  'settings.skillsDeleteConfirm': 'Silmeyi onayla',
  'settings.skillsName': 'Ad',
  'settings.skillsTriggers': 'Tetikleyiciler (virgül veya yeni satır ile ayrılmış)',
  'settings.skillsDescription': 'Açıklama',
  'settings.skillsBody': 'SKILL.md gövdesi',
  'settings.skillsCreate': 'Oluştur',
  'settings.skillsSave': 'Kaydet',
  'settings.skillsSaving': 'Kaydediliyor…',
  'settings.skillsFiles': 'Dosyalar',
    'settings.skillsNoFiles': 'Bu yetenek klasöründe dosya yok.',
  'settings.skillsNameRequired': 'Beceri adı gereklidir.',
  'settings.skillsBodyRequired': 'Beceri içeriği gereklidir.',
  'settings.designSystems': 'Tasarım sistemleri',
  'settings.designSystemsHint': 'Mevcut tasarım sistemlerini görün ve etkinleştirin',
  'settings.designSystemsInstalled': 'Yüklü',
  'settings.designSystemsAdd': 'Tasarım sistemi ekle',
  'settings.designSystemsHiddenCount': '{count} ana galeriden gizlendi',
  'settings.designSystemsShowAll': 'Tümünü göster',
  'settings.designSystemsShowHidden': 'Gizlenenleri göster',
  'settings.designSystemsSource': 'Kaynak',
  'settings.designSystemsSourceLocal': 'Yerel',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsStructure': 'Yapı',
  'settings.designSystemsModeHybrid': 'Hibrit',
  'settings.designSystemsModeNormalized': 'Normalize',
  'settings.designSystemsModeVerbatim': 'Olduğu gibi',
  'settings.designSystemsCraft': 'Craft',
  'settings.designSystemsCraftColor': 'Renk',
  'settings.designSystemsCraftAccessibility': 'Erişilebilirlik',
  'settings.designSystemsGithubUrl': 'GitHub URL’si',
  'settings.designSystemsProjectPath': 'Proje yolu',
  'settings.designSystemsImportGithub': 'GitHub’dan içe aktar',
  'settings.designSystemsImportProject': 'Projeden içe aktar',
  'settings.designSystemsImportedStatus': '{title} içe aktarıldı',
  'settings.designSystemsViewImported': 'İçe aktarılan tasarım sistemini görüntüle',
  'settings.designSystemsCategory': 'Kategori',
  'settings.designSystemsAllCategories': 'Tüm kategoriler',
  'settings.designSystemsShowInHomeGallery': 'Ana galeride göster',
  'settings.librarySkills': 'Beceriler',
  'settings.libraryDesignSystems': 'Tasarım sistemleri',
  'settings.librarySearch': 'Ara...',
  'settings.libraryAll': 'Tümü',
  'settings.libraryPreview': 'Önizleme',
  'settings.libraryPreviewClose': 'Kapat',
  'settings.libraryLoading': 'Yükleniyor...',
  'settings.libraryNoResults': 'Aramanızla eşleşen öğe bulunamadı.',
  'settings.libraryEnabled': 'Etkin',
  'settings.libraryDisabled': 'Devre dışı',
  'settings.connectorsNavHint': 'Harici sistem bağlantıları',
  'settings.connectorsHint': 'Bu cihaz için bağlayıcı ve araç sağlayıcı ayarlarını yönetin.',
  'settings.connectorsComposioApiKey': 'Composio API anahtarı',
  'settings.connectorsSavedTitle': 'Yerel daemon’a kaydedildi',
  'settings.connectorsSavedWithTail': 'Kaydedildi · ••••{tail}',
  'settings.connectorsSaved': 'Kaydedildi',
  'settings.connectorsGetApiKey': 'API anahtarı al',
  'settings.connectorsReplaceKeyPlaceholder': 'Kaydedilmiş anahtarı değiştirmek için yeni anahtar yapıştırın',
  'settings.connectorsApiKeyPlaceholder': 'Composio API anahtarını yapıştırın',
  'settings.connectorsClear': 'Temizle',
  'settings.connectorsClearConfirmTitle': 'Kaydedilmiş Composio API anahtarı temizlensin mi?',
  'settings.connectorsClearConfirmBody': 'Anahtarı kaldırmak bu çalışma alanına bağlı tüm Composio bağlayıcılarını koparır. Bağlı hesaplar, OAuth izinleri ve araç erişimleri tamamen kaldırılır.',
  'settings.connectorsClearConfirmContinue': 'Devam et',
  'settings.connectorsClearFinalTitle': 'Bu işlem tüm bağlayıcıların bağlantısını keser',
  'settings.connectorsClearFinalBody': 'Geri alınamaz. Yeni bir anahtar yapıştırdıktan sonra her entegrasyonu sıfırdan yeniden bağlamanız gerekir.',
  'settings.connectorsClearFinalConfirm': 'Anahtarı sil ve bağlantıyı kes',
  'settings.connectorsClearArming': 'Bir saniye\u2026',
  'settings.connectorsClearCancel': 'İptal',
  'settings.connectorsSaveKey': "Anahtarı kaydet",
  'settings.connectorsSaveKeyTitle': "Bu anahtarı yerel daemon’a gönder",
  'settings.connectorsKeySaving': "Kaydediliyor…",
  'settings.connectorsKeySaved': "Kaydedildi ✓",
  'settings.connectorsKeyError': "Anahtar kaydedilemedi. Yerel daemon’ın çalıştığını doğrulayın ve tekrar deneyin.",
  'settings.connectorsHelpSaved': 'Anahtarınız aşağıdaki kataloğu açar ve yerel daemon’da kalır. Değiştirmek için yeni anahtar yapıştırın veya kaldırmak için temizleyin.',
  'settings.connectorsHelpUnsaved': "Kaydedilmemiş değişiklikler — bu kimlik bilgisini yerel daemon’a kaydetmek ve aşağıdaki kataloğu açmak için Anahtarı kaydet’e tıklayın.",
  'settings.connectorsHelpEmpty': 'Aşağıdaki kataloğu açmak için bir anahtar ekleyin. Anahtarlar daemon’da yerel olarak saklanır ve ortam değişkenleriyle gönderilmez.',
  'settings.connectorsLoadingSavedKey': 'Yerel daemon’da kayıtlı anahtar aranıyor…',
  'settings.autosaveSaving': "Kaydediliyor…",
  'settings.autosaveSaved': "Tüm değişiklikler kaydedildi",
  'settings.autosaveError': "Değişiklikler kaydedilemedi. Yerel daemon çevrimdışı olabilir.",
  'settings.libraryToggleLabel': 'Değiştir',
  // Memory (auto-extracted personalization saved as on-disk markdown)
  'settings.memory': 'Memory',
  'settings.memoryHint': 'Personal facts auto-extracted from chats',
  'settings.memoryDescription': 'Auto-extracted facts about you and your preferences. Saved as Markdown files and folded into every chat.',
  'settings.memoryEnabled': 'Enabled',
  'settings.memoryDisabled': 'Disabled',
  'settings.memoryEnableLabel': 'Enable memory injection',
  'settings.memoryDisabledBanner': 'Memory is currently OFF. Existing facts are preserved on disk but will not be folded into new chats and new turns will not extract anything new.',
  'settings.memoryNew': 'New memory',
  'settings.memoryEdit': 'Edit',
  'settings.memoryDelete': 'Delete',
  'settings.memoryPreview': 'Preview',
  'settings.memoryEmpty': 'No memory yet.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'I prefer dark mode',
  'settings.memoryName': 'Name',
  'settings.memoryDesc': 'One-line description',
  'settings.memoryBody': 'Memory body (Markdown supported)',
  'settings.memoryBodyHint': 'Lead with the rule itself; add Why and How to apply lines.',
  'settings.memoryStartersLabel': 'Need a starting point? Click to fill the form:',
  'settings.memoryStarterUserName': 'My role',
  'settings.memoryStarterUserDesc': 'I am a frontend engineer working on a SaaS design tool',
  'settings.memoryStarterUserBody': '- Role: senior frontend engineer\n- Stack: React, TypeScript, Vite\n- Domain: design / collaboration tools\n- Timezone: GMT+8 (Asia/Shanghai)\n\nWhen to apply: any chat — frame examples around web frontend.',
  'settings.memoryStarterFeedbackName': 'UI preferences',
  'settings.memoryStarterFeedbackDesc': 'Dark mode, large body text, low information density',
  'settings.memoryStarterFeedbackBody': '- Theme: dark by default\n- Body text: ≥ 18px\n- Information density: prefer whitespace, fewer items per screen\n\nWhy: less eye strain during long sessions.\nWhen to apply: whenever you generate UI, web pages, or slides.',
  'settings.memoryStarterProjectName': 'Current project',
  'settings.memoryStarterProjectDesc': 'Open Design v0.5 — chat-driven design editor',
  'settings.memoryStarterProjectBody': '- Goal: ship the chat-driven editor this quarter\n- Priorities: streaming render, local multimodal, offline-first\n- Stack: Next.js 16, Express daemon, SQLite\n\nWhen to apply: in any conversation about this project.',
  'settings.memorySaveHint': 'Not auto-saved — click Create / Save to apply.',
  'settings.memoryIndexSaveHint': 'Edits to the index are not auto-saved — click Save index to apply.',
  'settings.memoryIndexUnsaved': 'Unsaved changes',
  'settings.memoryFlashCreated': '✓ Memory created',
  'settings.memoryFlashSaved': '✓ Memory saved',
  'settings.memoryFlashDeleted': '✓ Memory deleted',
  'settings.memoryFlashIndexSaved': '✓ Index saved',
  'settings.memoryFlashPathCopied': '✓ Yol kopyalandı',
  'settings.memoryNameLabel': 'Title',
  'settings.memoryTypeLabel': 'Type',
  'settings.memoryDescLabel': 'Description',
  'settings.memoryBodyLabel': 'Content',
  'settings.memoryTypeUser': 'User',
  'settings.memoryTypeFeedback': 'Feedback',
  'settings.memoryTypeProject': 'Project',
  'settings.memoryTypeReference': 'Reference',
  'settings.memoryIndex': 'MEMORY.md (index)',
  'settings.memoryIndexSave': 'Save index',
  'settings.memoryIndexReset': 'Reset',
  'settings.memoryToastChanged': 'Memory updated',
  'settings.memoryToastClickHint': 'Görüntüle',
  'settings.memoryAll': 'All',
  'settings.memoryExtractions': 'Extraction history',
  'settings.memoryExtractionsHint': 'Recent LLM-backed extraction attempts. Heuristic regex extraction always runs first; LLM extraction runs in the background after each turn.',
  'settings.memoryExtractionsEmpty': 'No extractions yet. The next chat turn will populate this list.',
  'settings.memoryExtractionsRefresh': 'Refresh',
  'settings.memoryExtractionsRefreshing': 'Refreshing…',
  'settings.memoryExtractionPhaseRunning': 'Running…',
  'settings.memoryExtractionPhaseSuccess': 'Success',
  'settings.memoryExtractionPhaseSkipped': 'Skipped',
  'settings.memoryExtractionPhaseFailed': 'Failed',
  'settings.memoryExtractionSkipNoProvider': 'No API key configured for LLM memory extraction.',
  'settings.memoryExtractionSkipDisabled': 'Memory is disabled.',
  'settings.memoryExtractionSkipEmpty': 'Empty user message — nothing to extract.',
  'settings.memoryExtractionSkipNoMatch': 'No regex pattern matched this turn.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'media settings',
  'settings.memoryExtractionProposed': 'proposed',
  'settings.memoryExtractionWritten': 'written',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryNoProviderBannerTitle': 'LLM memory extraction is not running',
  'settings.memoryNoProviderBannerBody': 'No API key found for the memory extractor. Add an OpenAI key under Media providers, or set ANTHROPIC_API_KEY / OPENAI_API_KEY in the environment, to enable LLM-driven extraction. Heuristic regex extraction is still active.',
  'settings.memoryExtractionProviderOverride': 'memory settings',
  'settings.memoryExtractionDelete': 'Delete',
  'settings.memoryExtractionsClear': 'Clear',
  'settings.memoryExtractionsClearTitle': 'Clear all extraction history',
  'settings.libraryInstall': 'Yükle',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Yerel yol',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Yükle',
  'settings.libraryUninstall': 'Kaldır',
  'settings.libraryBuiltIn': 'Yerleşik',
  'settings.libraryInstalled': 'Yüklü',
  'notify.successTitle': 'Görev tamamlandı',
  'notify.failureTitle': 'Görev başarısız oldu',
  'notify.successBody': 'Bir tur tamamlandı.',
  'notify.failureBody': 'Görev bir hata ile sona erdi.',
  'updater.available': 'Güncelleme mevcut',
  'updater.availableBody': 'Open Design {version} mevcut. Yükleyici açılmadan önce indirilecek.',
  'updater.checking': 'Güncellemeler denetleniyor',
  'updater.download': 'Güncellemeyi indir',
  'updater.downloading': 'Güncelleme indiriliyor',
  'updater.downloadingPercent': 'Güncelleme indiriliyor {percent}%',
  'updater.done': 'Tamam',
  'updater.failed': 'Güncelleme başarısız',
  'updater.installerOpenBody': 'Yükleyici açık. Güncellemeyi tamamlayabilmeniz için Open Design kapatılıyor.',
  'updater.installerOpened': 'Yükleyici açıldı',
  'updater.later': 'Daha sonra',
  'updater.openFailedFallback': 'Yükleyici açılamadı.',
  'updater.openInstaller': 'Güncellemeyi yükle',
  'updater.opening': 'Yükleyici açılıyor...',
  'updater.quitButton': 'Open Design’dan çık',
  'updater.quitFailedBody': 'Yükleyici açık, ancak Open Design kapatılamadı. Uygulamayı değiştirmeden önce Open Design’dan çıkın.',
  'updater.quitFailedTitle': 'Çıkılamadı',
  'updater.quitting': 'Çıkılıyor...',
  'updater.ready': 'Güncelleme hazır',
  'updater.readyGeneric': 'Yeni bir sürüm hazır. Open Design kapanıp yükleyiciyi açacak.',
  'updater.readyVersion': 'Open Design {version} hazır. Open Design kapanıp yükleyiciyi açacak.',
  'updater.upToDate': 'Zaten en son sürümdesiniz.',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'settings.orbit.eyebrow': 'Otomasyon',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Günlük bağlayıcı özeti',
  'settings.orbit.lede': 'Bağlayıcı etkinliğini bir zamanlamaya göre topla ve sonucu yenilenebilir bir live artifact olarak yayımla.',
  'settings.orbit.statusOnTitle': 'Zamanlanmış günlük çalıştırmalar açık',
  'settings.orbit.statusOffTitle': 'Zamanlanmış günlük çalıştırmalar kapalı',
  'settings.orbit.statusActive': 'Aktif',
  'settings.orbit.statusOff': 'Kapalı',
  'settings.orbit.runTitle': 'Bir Orbit çalıştırması başlat ve canlı konuşmayı aç',
  'settings.orbit.running': 'Çalışıyor…',
  'settings.orbit.runOpen': 'Şimdi çalıştır',
  'settings.orbit.dailySummaryTitle': 'Günlük özet',
  'settings.orbit.dailySummarySub': 'Zamanlanan yerel saatte günde bir kez çalışır.',
  'settings.orbit.on': 'Açık',
  'settings.orbit.off': 'Kapalı',
  'settings.orbit.runTimeTitle': 'Çalıştırma zamanı',
  'settings.orbit.runTimeSub': 'Varsayılan 08:00. daemon zamanlamasına uygulamak için kaydet.',
  'settings.orbit.runTimeAria': 'Günlük Orbit çalıştırma zamanı',
  'settings.orbit.nextRun': 'Sonraki çalıştırma',
  'settings.orbit.nextRunScheduledAfterSave': 'Kaydettikten sonra zamanlanır',
  'settings.orbit.schedule': 'Zamanlama',
  'settings.orbit.pausedManualOnly': 'Duraklatıldı — yalnızca manuel çalıştırmalar',
  'settings.orbit.templateTitle': 'Prompt şablonu',
  'settings.orbit.templateMissing': '{id} şablonu yüklü değil.',
  'settings.orbit.templateMissingOption': '{id} (eksik)',
  'settings.orbit.templateMissingInstall': 'Promptu yönlendirmek için bir Orbit skill yükleyin.',
  'settings.orbit.templateMissingPickAnother': 'Açılır menüden başka bir şablon seçin.',
  'settings.orbit.templateResetTitle': '{id} değerine sıfırla',
  'settings.orbit.templateReset': 'Sıfırla',
  'settings.orbit.templateHelp': 'Orbit’i bir skill ile yönlendir — seçilen şablonun örnek promptu her Orbit çalıştırmasına eklenir, böylece özetler o şablonun biçimini izler.',
  'settings.orbit.templateAria': 'Orbit prompt şablonu',
  'settings.orbit.templatesLoading': 'Şablonlar yükleniyor…',
  'settings.orbit.templatesOptgroup': 'Orbit skill şablonları',
  'settings.orbit.lastRun': 'Son çalıştırma',
  'settings.orbit.triggerManual': 'Manuel',
  'settings.orbit.triggerScheduled': 'Zamanlandı',
  'settings.orbit.meterAria': '{checked} kontrolden {succeeded} başarılı, {skipped} atlandı, {failed} başarısız',
  'settings.orbit.countChecked': 'Kontrol edildi',
  'settings.orbit.countSucceeded': 'Başarılı',
  'settings.orbit.countSkipped': 'Atlandı',
  'settings.orbit.countFailed': 'Başarısız',
  'settings.orbit.runError': 'Orbit çalıştırılamadı. Yerel daemon’ın çalıştığından ve bağlayıcıların yapılandırıldığından emin olun.',
  'settings.orbit.gateAriaLabel': "Orbit’i kullanmak için bağlayıcılar gerekiyor",
  'settings.orbit.gateEyebrow': "Kurulum gerekli",
  'settings.orbit.gateTitle': "Orbit’i çalıştırmak için bir araç bağlayın",
  'settings.orbit.gateBody': "Orbit, bağlayıcılarınızın etkinliğini özetler. Henüz hiçbir şey bağlamadınız — Orbit’in raporlayacak bir şeyi olması için en az bir entegrasyon ekleyin.",
  'settings.orbit.gateBodyNoKey': "Orbit, bağlayıcılarınızın etkinliğini özetler ve bağlayıcılar Composio üzerinden çalışır. Kataloğu açmak ve ilk entegrasyonunuzu seçmek için Bağlayıcılar bölümüne bir Composio API anahtarı ekleyin.",
  'settings.orbit.gateAction': "Bağlayıcıları aç",
  'settings.orbit.gateActionNoKey': "Composio’yu yapılandır",
  'settings.orbit.gateLoading': "Bağlayıcılarınız kontrol ediliyor…",
  'settings.orbit.controlsLockedBadge': "Kilitli",
  'settings.orbit.controlsLockedHint': "Orbit'in zamanlama ve şablon kontrollerini açmak için bir araç bağlayın.",
  'settings.orbit.artifactKickerLive': 'live artifact',
  'settings.orbit.artifactKickerLegacy': 'Eski özet',
  'settings.orbit.artifactTitle': 'Günlük Orbit etkinlik özeti',
  'settings.orbit.artifactMetaLive': 'Bağlayıcı etkinliğinden oluşturulan yenilenebilir HTML artifact.',
  'settings.orbit.artifactMetaLegacy': 'live artifact desteği etkinleştirilmeden önce oluşturuldu — bir tane yayımlamak için Orbit’i yeniden çalıştırın.',
  'settings.orbit.copyMarkdownTitle': 'Markdown özetini panoya kopyala',
  'settings.orbit.copied': 'Kopyalandı',
  'settings.orbit.copy': 'Kopyala',
  'settings.orbit.openArtifact': 'Artifact aç',
  'settings.orbit.sourceMarkdown': 'Kaynak Markdown',
  'liveArtifact.viewer.tabPreview': 'Önizleme',
  'liveArtifact.viewer.tabCode': 'Kod',
  'liveArtifact.viewer.tabData': 'Veri',
  'liveArtifact.viewer.tabRefreshHistory': 'Yenileme geçmişi',
  'liveArtifact.viewer.dataEmpty': 'Kullanılabilir data.json önbelleği yok.',
  'liveArtifact.viewer.code.templateHeading': 'Şablon HTML',
  'liveArtifact.viewer.code.renderedHeading': 'Oluşturulan HTML',
  'liveArtifact.viewer.code.templateHelp': 'Önizlemeyi oluşturmak için data.json ile kullanılan düzenlenebilir şablon.',
  'liveArtifact.viewer.code.renderedHelp': 'Önizleme tarafından şu anda yüklenen oluşturulmuş index.html.',
  'liveArtifact.viewer.code.variantAria': 'Kod varyantı',
  'liveArtifact.viewer.code.variantTemplate': 'Şablon',
  'liveArtifact.viewer.code.variantRendered': 'Oluşturuldu',
  'liveArtifact.viewer.code.loading': 'Kod yükleniyor…',
  'liveArtifact.viewer.code.unavailable': 'Kod henüz kullanılamıyor.',
  'liveArtifact.viewer.code.empty': 'Bu kod dosyası boş.',
  // Diagnostics export
  'diagnostics.exportTitle': 'Tanılama dışa aktar',
  'diagnostics.exportButton': 'Tanılama dışa aktar',
  'diagnostics.exportHint': 'Son uygulama günlüklerini ve makine bilgilerini ekibe gönderebileceğiniz bir zip dosyasında paketler.',
  'diagnostics.exporting': 'Dışa aktarılıyor…',
  'diagnostics.exportSuccess': 'Tanılama {path} konumuna kaydedildi',
  'diagnostics.exportFailed': 'Tanılama dışa aktarılamadı: {message}',
};
